/* eslint-disable */
// Auto-generated from temp/Finlay Clinical Laboratory - FHC Health Plan Lab Capitation and Fee For Service  Proposal Final - CP.xlsx
export const finlayLabCosts = {
  "phcRates": [
    {
      "testName": "17-ALPHA HYDROPROGESTEROM",
      "testCode": "",
      "price": 41.4,
      "cptCode": null
    },
    {
      "testName": "AB SCREEN (ANTIBODY SCREENING)",
      "testCode": "",
      "price": 10,
      "cptCode": null
    },
    {
      "testName": "ABO AB SCREEN",
      "testCode": "",
      "price": 10,
      "cptCode": null
    },
    {
      "testName": "ABO GROUP & AB SCREEN",
      "testCode": "",
      "price": 20,
      "cptCode": null
    },
    {
      "testName": "ABO RH (BLOOD GROUP)",
      "testCode": "",
      "price": 10,
      "cptCode": null
    },
    {
      "testName": "ABSCESS CULTURE",
      "testCode": "",
      "price": 14,
      "cptCode": null
    },
    {
      "testName": "ACTH (ADRENOCORTICOTROPIC HORMONE)",
      "testCode": "",
      "price": 40,
      "cptCode": null
    },
    {
      "testName": "AFP",
      "testCode": "",
      "price": 14,
      "cptCode": null
    },
    {
      "testName": "AFP TUMOR MARKER",
      "testCode": "",
      "price": 14,
      "cptCode": null
    },
    {
      "testName": "ALBUMIN",
      "testCode": "",
      "price": 5,
      "cptCode": null
    },
    {
      "testName": "ALBUMIN CREATININE RATION URINE",
      "testCode": "",
      "price": 10,
      "cptCode": null
    },
    {
      "testName": "ALBUMIN URINE RANDOM",
      "testCode": "",
      "price": 10,
      "cptCode": null
    },
    {
      "testName": "ALCOHOL IN URINE",
      "testCode": "",
      "price": 10,
      "cptCode": null
    },
    {
      "testName": "ALDOLASE",
      "testCode": "",
      "price": 9.5,
      "cptCode": null
    },
    {
      "testName": "ALKALINE PHOSPHATASE",
      "testCode": "",
      "price": 5,
      "cptCode": null
    },
    {
      "testName": "ALLERGEN FOOD PANEL (ADULT) eachallergen ($9)",
      "testCode": "",
      "price": 50,
      "cptCode": null
    },
    {
      "testName": "ALLERGEN RESPIRATORY PANEL(SUB-TROPICAL) eachallergen ($9)",
      "testCode": "",
      "price": 150,
      "cptCode": null
    },
    {
      "testName": "ALLERGY FOOD PANEL",
      "testCode": "",
      "price": 95,
      "cptCode": null
    },
    {
      "testName": "ALLERGY PANEL PER ALLERGENeachallergen($9)",
      "testCode": "",
      "price": 10,
      "cptCode": null
    },
    {
      "testName": "ALPHA PHETO PROTEIN QUAD SCREEN",
      "testCode": "",
      "price": 59,
      "cptCode": null
    },
    {
      "testName": "ALPHA PHETO PROTEIN TRIPLE SCREEN",
      "testCode": "",
      "price": 73,
      "cptCode": null
    },
    {
      "testName": "AFB",
      "testCode": "",
      "price": 30,
      "cptCode": null
    },
    {
      "testName": "AFB CULTURE AND STAIN",
      "testCode": "",
      "price": 30,
      "cptCode": null
    },
    {
      "testName": "ALT",
      "testCode": "",
      "price": 5,
      "cptCode": null
    },
    {
      "testName": "AMMONIA",
      "testCode": "",
      "price": 10,
      "cptCode": null
    },
    {
      "testName": "AMIKACIN SERUM",
      "testCode": "",
      "price": 14,
      "cptCode": null
    },
    {
      "testName": "AMYLASE",
      "testCode": "",
      "price": 6,
      "cptCode": null
    },
    {
      "testName": "ANEMIA PROFILE",
      "testCode": "",
      "price": 65,
      "cptCode": null
    },
    {
      "testName": "ANEMIA PROFILE I",
      "testCode": "",
      "price": 75,
      "cptCode": null
    },
    {
      "testName": "ANEMIA PROFILE II",
      "testCode": "",
      "price": 85,
      "cptCode": null
    },
    {
      "testName": "ANTI-CCP",
      "testCode": "",
      "price": 25,
      "cptCode": null
    },
    {
      "testName": "ANTI -DNA",
      "testCode": "",
      "price": 25,
      "cptCode": null
    },
    {
      "testName": "ANTI-PLAT.AB",
      "testCode": "",
      "price": 550,
      "cptCode": null
    },
    {
      "testName": "ANTI MULLERIAN HORMONE",
      "testCode": "",
      "price": 190,
      "cptCode": null
    },
    {
      "testName": "ANTI-THYROGLOBULIN ab (ATG)",
      "testCode": "",
      "price": 20,
      "cptCode": null
    },
    {
      "testName": "ANTI-THYROID ANTIBODY",
      "testCode": "",
      "price": 20,
      "cptCode": null
    },
    {
      "testName": "ANA W/REFLEX",
      "testCode": "",
      "price": 25,
      "cptCode": null
    },
    {
      "testName": "AMA",
      "testCode": "",
      "price": 30,
      "cptCode": null
    },
    {
      "testName": "ARTHRITIS PANEL",
      "testCode": "",
      "price": 30,
      "cptCode": null
    },
    {
      "testName": "ASMA",
      "testCode": "",
      "price": 68,
      "cptCode": null
    },
    {
      "testName": "ASO LATEX",
      "testCode": "",
      "price": 10,
      "cptCode": null
    },
    {
      "testName": "AST (SGOT)",
      "testCode": "",
      "price": 5,
      "cptCode": null
    },
    {
      "testName": "B-12 & FOLID ACID",
      "testCode": "",
      "price": 20,
      "cptCode": null
    },
    {
      "testName": "B-12",
      "testCode": "",
      "price": 10,
      "cptCode": null
    },
    {
      "testName": "BASIC METAB PANEL",
      "testCode": "",
      "price": 8,
      "cptCode": null
    },
    {
      "testName": "BETA 2 MICROGLOBULIN",
      "testCode": "",
      "price": 16,
      "cptCode": null
    },
    {
      "testName": "BIOPSY",
      "testCode": "",
      "price": 50,
      "cptCode": null
    },
    {
      "testName": "BIOPSY - Level I - Gross only",
      "testCode": "",
      "price": 30,
      "cptCode": null
    },
    {
      "testName": "BIOPSY - Level II",
      "testCode": "",
      "price": 40,
      "cptCode": null
    },
    {
      "testName": "BIOPSY - Level III",
      "testCode": "",
      "price": 65,
      "cptCode": null
    },
    {
      "testName": "BIOPSY - Level IV",
      "testCode": "",
      "price": 85,
      "cptCode": null
    },
    {
      "testName": "BILIRUBIN DIRECT",
      "testCode": "",
      "price": 4,
      "cptCode": null
    },
    {
      "testName": "BILIRUBIN INDIRECT",
      "testCode": "",
      "price": 4,
      "cptCode": null
    },
    {
      "testName": "BILIRUBIN TOTAL",
      "testCode": "",
      "price": 4,
      "cptCode": null
    },
    {
      "testName": "BLEEDING TIME",
      "testCode": "",
      "price": 4.5,
      "cptCode": null
    },
    {
      "testName": "BUN",
      "testCode": "",
      "price": 4,
      "cptCode": null
    },
    {
      "testName": "C3 COMPLEMENT",
      "testCode": "",
      "price": 16,
      "cptCode": null
    },
    {
      "testName": "C4 COMPLEMENT",
      "testCode": "",
      "price": 16,
      "cptCode": null
    },
    {
      "testName": "CA 125",
      "testCode": "",
      "price": 19.5,
      "cptCode": null
    },
    {
      "testName": "CA 15-3",
      "testCode": "",
      "price": 19.5,
      "cptCode": null
    },
    {
      "testName": "CA 19-9",
      "testCode": "",
      "price": 19.5,
      "cptCode": null
    },
    {
      "testName": "CA 27-29",
      "testCode": "",
      "price": 19.5,
      "cptCode": null
    },
    {
      "testName": "CALCIUM",
      "testCode": "",
      "price": 4,
      "cptCode": null
    },
    {
      "testName": "CALCIUM IONIZED",
      "testCode": "",
      "price": 60,
      "cptCode": null
    },
    {
      "testName": "CALCULUS (stone) ANALYSIS",
      "testCode": "",
      "price": 30,
      "cptCode": null
    },
    {
      "testName": "CALCITONIN",
      "testCode": "",
      "price": 40,
      "cptCode": null
    },
    {
      "testName": "CARBAMAZEPIN",
      "testCode": "",
      "price": 13,
      "cptCode": null
    },
    {
      "testName": "CARDIAC PANEL",
      "testCode": "",
      "price": 28,
      "cptCode": null
    },
    {
      "testName": "CARDIAC PROFILE",
      "testCode": "",
      "price": 64.82,
      "cptCode": null
    },
    {
      "testName": "CBC",
      "testCode": "",
      "price": 5,
      "cptCode": null
    },
    {
      "testName": "CBC W/DIF",
      "testCode": "",
      "price": 3.9,
      "cptCode": null
    },
    {
      "testName": "CCP ANTIBODIES",
      "testCode": "",
      "price": 25,
      "cptCode": null
    },
    {
      "testName": "CD4",
      "testCode": "",
      "price": 52,
      "cptCode": null
    },
    {
      "testName": "CD8",
      "testCode": "",
      "price": 65,
      "cptCode": null
    },
    {
      "testName": "CEA (Carcinoembryonic Antigen)",
      "testCode": "",
      "price": 15,
      "cptCode": null
    },
    {
      "testName": "CELIAC PANEL",
      "testCode": "",
      "price": 285,
      "cptCode": null
    },
    {
      "testName": "CERULOPLASMIN",
      "testCode": "",
      "price": 55,
      "cptCode": null
    },
    {
      "testName": "CHLAMYDIA & GC IN URINE",
      "testCode": "",
      "price": 30,
      "cptCode": null
    },
    {
      "testName": "CHLAMYDIA & GC IN URINE AMPLIFIED PROBE",
      "testCode": "",
      "price": 30,
      "cptCode": null
    },
    {
      "testName": "CHLAMYDIA & GC DNA",
      "testCode": "",
      "price": 30,
      "cptCode": null
    },
    {
      "testName": "CHLAMYDIA & GC DNA hc2",
      "testCode": "",
      "price": 35,
      "cptCode": null
    },
    {
      "testName": "CHOLESTEROL",
      "testCode": "",
      "price": 5,
      "cptCode": null
    },
    {
      "testName": "CHLORIDE",
      "testCode": "",
      "price": 4,
      "cptCode": null
    },
    {
      "testName": "CLOSTRIDIUM DIFFICILE A",
      "testCode": "",
      "price": 19,
      "cptCode": null
    },
    {
      "testName": "CLOSTRIDIUM DIFFICILE B",
      "testCode": "",
      "price": 19,
      "cptCode": null
    },
    {
      "testName": "CLOSTRIDIUM DIFFICILE A/B",
      "testCode": "",
      "price": 19.95,
      "cptCode": null
    },
    {
      "testName": "CLOZAPINE",
      "testCode": "",
      "price": 95,
      "cptCode": null
    },
    {
      "testName": "CK (CPK TOTAL)",
      "testCode": "",
      "price": 7,
      "cptCode": null
    },
    {
      "testName": "CMP",
      "testCode": "",
      "price": 7.2,
      "cptCode": null
    },
    {
      "testName": "CMVlgG",
      "testCode": "",
      "price": 18,
      "cptCode": null
    },
    {
      "testName": "CMVlgM",
      "testCode": "",
      "price": 18,
      "cptCode": null
    },
    {
      "testName": "CO2 - BICARBONATO",
      "testCode": "",
      "price": 4,
      "cptCode": null
    },
    {
      "testName": "COENZIME Q10",
      "testCode": "",
      "price": 65,
      "cptCode": null
    },
    {
      "testName": "COMPRÉNH. METABOLIC PANEL",
      "testCode": "",
      "price": 10,
      "cptCode": null
    },
    {
      "testName": "COOMBS DIRECT",
      "testCode": "",
      "price": 10,
      "cptCode": null
    },
    {
      "testName": "COOMBS INDIRECT",
      "testCode": "",
      "price": 10,
      "cptCode": null
    },
    {
      "testName": "COPPER",
      "testCode": "",
      "price": 18,
      "cptCode": null
    },
    {
      "testName": "CORTISOL",
      "testCode": "",
      "price": 20,
      "cptCode": null
    },
    {
      "testName": "COVID-19 IgG - QUAMTITATIVE (SPIKE)",
      "testCode": "",
      "price": 55,
      "cptCode": null
    },
    {
      "testName": "COVID-19 IgG/IgM - QUAMTITATIVE",
      "testCode": "",
      "price": 40,
      "cptCode": null
    },
    {
      "testName": "CLOSTRIDIUM DIFF.",
      "testCode": "",
      "price": 19.95,
      "cptCode": null
    },
    {
      "testName": "C-PEPTIDE",
      "testCode": "",
      "price": 30,
      "cptCode": null
    },
    {
      "testName": "CPK Total",
      "testCode": "",
      "price": 5,
      "cptCode": null
    },
    {
      "testName": "CPK - MB (CREATINE KINASE MB FRACTION)",
      "testCode": "",
      "price": 20,
      "cptCode": null
    },
    {
      "testName": "C-REACTIVE PROTEIN - QUANT",
      "testCode": "",
      "price": 8.9,
      "cptCode": null
    },
    {
      "testName": "C-REACTIVE PROTEIN (CRP)",
      "testCode": "",
      "price": 5,
      "cptCode": null
    },
    {
      "testName": "C-REACTIVE PROTEIN (CRP) ULTRASENSITIVE",
      "testCode": "",
      "price": 12.5,
      "cptCode": null
    },
    {
      "testName": "CREATININE 24 HRS",
      "testCode": "",
      "price": 5,
      "cptCode": null
    },
    {
      "testName": "CREATININE CLEARANCE",
      "testCode": "",
      "price": 8,
      "cptCode": null
    },
    {
      "testName": "CREATININE KINASE TOTAL (CK)",
      "testCode": "",
      "price": 5,
      "cptCode": null
    },
    {
      "testName": "CREATININE SERUM",
      "testCode": "",
      "price": 4,
      "cptCode": null
    },
    {
      "testName": "CREATININE RANDOM URINE",
      "testCode": "",
      "price": 5,
      "cptCode": null
    },
    {
      "testName": "CREATININE URINE 24 HRS",
      "testCode": "",
      "price": 5,
      "cptCode": null
    },
    {
      "testName": "CRP",
      "testCode": "",
      "price": 8.9,
      "cptCode": null
    },
    {
      "testName": "CULTURE & SENSIT",
      "testCode": "",
      "price": 12,
      "cptCode": null
    },
    {
      "testName": "CYSTATIN C",
      "testCode": "",
      "price": 35,
      "cptCode": null
    },
    {
      "testName": "CYSTIC FIBROSIS",
      "testCode": "",
      "price": 250,
      "cptCode": null
    },
    {
      "testName": "DEPAKENE (VALPROIC ACID)",
      "testCode": "",
      "price": 12,
      "cptCode": null
    },
    {
      "testName": "DHEA (DEHYDROEPIANDROSTERONE)",
      "testCode": "",
      "price": 26,
      "cptCode": null
    },
    {
      "testName": "DHEA (DEHYDROEPIANDROSTERONE SALFATE)",
      "testCode": "",
      "price": 20,
      "cptCode": null
    },
    {
      "testName": "DIGOXIN",
      "testCode": "",
      "price": 10,
      "cptCode": null
    },
    {
      "testName": "DIHYDROTESTOSTERONE DHT",
      "testCode": "",
      "price": 35,
      "cptCode": null
    },
    {
      "testName": "D-DIMER",
      "testCode": "",
      "price": 15,
      "cptCode": null
    },
    {
      "testName": "DILANTIN LEVEL",
      "testCode": "",
      "price": 12,
      "cptCode": null
    },
    {
      "testName": "DRUG SCREEN IN URINE",
      "testCode": "",
      "price": 23,
      "cptCode": null
    },
    {
      "testName": "DRUG SCREEN 5",
      "testCode": "",
      "price": 25.9,
      "cptCode": null
    },
    {
      "testName": "DRUG SCREEN 8",
      "testCode": "",
      "price": 35,
      "cptCode": null
    },
    {
      "testName": "EAR AND SENSITIVITY",
      "testCode": "",
      "price": 12,
      "cptCode": null
    },
    {
      "testName": "ELECTROLYTE PANEL",
      "testCode": "",
      "price": 4.5,
      "cptCode": null
    },
    {
      "testName": "ENA",
      "testCode": "",
      "price": 40,
      "cptCode": null
    },
    {
      "testName": "ERYTHROPOIETIN",
      "testCode": "",
      "price": 39,
      "cptCode": null
    },
    {
      "testName": "ESTRADIOL",
      "testCode": "",
      "price": 15,
      "cptCode": null
    },
    {
      "testName": "ESTRIOL",
      "testCode": "",
      "price": 20,
      "cptCode": null
    },
    {
      "testName": "ESTROGEN TOTAL",
      "testCode": "",
      "price": 22,
      "cptCode": null
    },
    {
      "testName": "ESR (SED RATE )",
      "testCode": "",
      "price": 6,
      "cptCode": null
    },
    {
      "testName": "EYE AND SENSITIVITY",
      "testCode": "",
      "price": 12,
      "cptCode": null
    },
    {
      "testName": "EYE CULTURE & SENSITIVITY",
      "testCode": "",
      "price": 12,
      "cptCode": null
    },
    {
      "testName": "FECAL GLOBYN BY IMMUNOCHEMISTRY",
      "testCode": "",
      "price": 13,
      "cptCode": null
    },
    {
      "testName": "FERRITIN",
      "testCode": "",
      "price": 15,
      "cptCode": null
    },
    {
      "testName": "FIBRINOGEN",
      "testCode": "",
      "price": 50,
      "cptCode": null
    },
    {
      "testName": "FOLIC ACID (FOLATE )",
      "testCode": "",
      "price": 10,
      "cptCode": null
    },
    {
      "testName": "FOOD ALLERGY",
      "testCode": "",
      "price": 110,
      "cptCode": null
    },
    {
      "testName": "FOOD ALLERGY PROFILE I",
      "testCode": "",
      "price": 120,
      "cptCode": null
    },
    {
      "testName": "FOOD ALLERGY PROFILE II",
      "testCode": "",
      "price": 110,
      "cptCode": null
    },
    {
      "testName": "FREE T3",
      "testCode": "",
      "price": 7,
      "cptCode": null
    },
    {
      "testName": "FREE T4",
      "testCode": "",
      "price": 7,
      "cptCode": null
    },
    {
      "testName": "FEMALE ENDOCRINE PROFILE",
      "testCode": "",
      "price": 182.5,
      "cptCode": null
    },
    {
      "testName": "FSH",
      "testCode": "",
      "price": 10,
      "cptCode": null
    },
    {
      "testName": "FSH & LH",
      "testCode": "",
      "price": 20,
      "cptCode": null
    },
    {
      "testName": "FINE NEEDLE ASPIRATION",
      "testCode": "",
      "price": 69,
      "cptCode": null
    },
    {
      "testName": "FRUCTOSAMINE",
      "testCode": "",
      "price": 32,
      "cptCode": null
    },
    {
      "testName": "FTA AG",
      "testCode": "",
      "price": 45,
      "cptCode": null
    },
    {
      "testName": "FUNGUS CULTURE",
      "testCode": "",
      "price": 16.5,
      "cptCode": null
    },
    {
      "testName": "GENTAMYCIN",
      "testCode": "",
      "price": 25,
      "cptCode": null
    },
    {
      "testName": "GC CULTURE",
      "testCode": "",
      "price": 30,
      "cptCode": null
    },
    {
      "testName": "GGT",
      "testCode": "",
      "price": 10,
      "cptCode": null
    },
    {
      "testName": "GGTP (GAMMA GT )",
      "testCode": "",
      "price": 5,
      "cptCode": null
    },
    {
      "testName": "GLIADIN IgA,IgG",
      "testCode": "",
      "price": 80,
      "cptCode": null
    },
    {
      "testName": "GROUP & FACTOR",
      "testCode": "",
      "price": 10,
      "cptCode": null
    },
    {
      "testName": "GLUCOSE 2 HRS P.P",
      "testCode": "",
      "price": 4,
      "cptCode": null
    },
    {
      "testName": "GLUCOSE 2 HRS TOLERANCE",
      "testCode": "",
      "price": 8,
      "cptCode": null
    },
    {
      "testName": "GLUCOSE 3 HRS",
      "testCode": "",
      "price": 12,
      "cptCode": null
    },
    {
      "testName": "GLUCOSE GRAY TUBE",
      "testCode": "",
      "price": 4,
      "cptCode": null
    },
    {
      "testName": "GLUCOSE SERUM (FASTING )",
      "testCode": "",
      "price": 4,
      "cptCode": null
    },
    {
      "testName": "GLYCOHEMOGLOBIN",
      "testCode": "",
      "price": 10,
      "cptCode": null
    },
    {
      "testName": "H PYLORI AB IgG",
      "testCode": "",
      "price": 10,
      "cptCode": null
    },
    {
      "testName": "H PYLORI BREATH",
      "testCode": "",
      "price": 55,
      "cptCode": null
    },
    {
      "testName": "H PYLORY IgM",
      "testCode": "",
      "price": 15,
      "cptCode": null
    },
    {
      "testName": "H PYLORI IN STOOL (ANTIGEN )",
      "testCode": "",
      "price": 39,
      "cptCode": null
    },
    {
      "testName": "H PYLORI QUALITATIVE",
      "testCode": "",
      "price": 7.15,
      "cptCode": null
    },
    {
      "testName": "HAPTOGLOBULIN",
      "testCode": "",
      "price": 28,
      "cptCode": null
    },
    {
      "testName": "HCG QUAL.",
      "testCode": "",
      "price": 7,
      "cptCode": null
    },
    {
      "testName": "HCH QUANT.",
      "testCode": "",
      "price": 10.94,
      "cptCode": null
    },
    {
      "testName": "HCG (Pregnancy Test) URINE",
      "testCode": "",
      "price": 5,
      "cptCode": null
    },
    {
      "testName": "HDL CHOLESTEROL",
      "testCode": "",
      "price": 6,
      "cptCode": null
    },
    {
      "testName": "HEMOGLOBIN A1C",
      "testCode": "",
      "price": 9,
      "cptCode": null
    },
    {
      "testName": "HEMOGLOBIN  ELECTROPHORESIS",
      "testCode": "",
      "price": 23,
      "cptCode": null
    },
    {
      "testName": "HEMOGLOBIN/HEMATROCRIT",
      "testCode": "",
      "price": 4,
      "cptCode": null
    },
    {
      "testName": "HEPATIC FUNTION PANEL (LFP)",
      "testCode": "",
      "price": 5.5,
      "cptCode": null
    },
    {
      "testName": "HEPATITIS A IgM",
      "testCode": "",
      "price": 11.5,
      "cptCode": null
    },
    {
      "testName": "HEPATITIS A TOTAL",
      "testCode": "",
      "price": 10.5,
      "cptCode": null
    },
    {
      "testName": "HEPATITIS B Ags",
      "testCode": "",
      "price": 15.79,
      "cptCode": null
    },
    {
      "testName": "HEPATITIS B CORE IgM AB",
      "testCode": "",
      "price": 11,
      "cptCode": null
    },
    {
      "testName": "HEPATITIS B CORE TOTAL AB",
      "testCode": "",
      "price": 11,
      "cptCode": null
    },
    {
      "testName": "HEPATITIS Bs AB",
      "testCode": "",
      "price": 11,
      "cptCode": null
    },
    {
      "testName": "HEPATITIIS Bs AG",
      "testCode": "",
      "price": 10,
      "cptCode": null
    },
    {
      "testName": "HEPATITIS B SURFACE AB",
      "testCode": "",
      "price": 22,
      "cptCode": null
    },
    {
      "testName": "HEPATITIS C AB",
      "testCode": "",
      "price": 13.5,
      "cptCode": null
    },
    {
      "testName": "HEPATITIS C Antibodies",
      "testCode": "",
      "price": 19,
      "cptCode": null
    },
    {
      "testName": "HEPATITIS C RNA QUANT, PCR",
      "testCode": "",
      "price": 70,
      "cptCode": null
    },
    {
      "testName": "HEPATITIS PANEL ABC",
      "testCode": "",
      "price": 35,
      "cptCode": null
    },
    {
      "testName": "HEPATITIS PANEL ACUTE (Hep A, IgM, Hep B Ag Sur, Hep C Ab)",
      "testCode": "",
      "price": 51,
      "cptCode": null
    },
    {
      "testName": "HERPES CULTURE",
      "testCode": "",
      "price": 35,
      "cptCode": null
    },
    {
      "testName": "HERPES I ( IgG )",
      "testCode": "",
      "price": 12.5,
      "cptCode": null
    },
    {
      "testName": "HERPES II ( IgG )",
      "testCode": "",
      "price": 15.79,
      "cptCode": null
    },
    {
      "testName": "HERPES I  & II  ( IgM )",
      "testCode": "",
      "price": 18.5,
      "cptCode": null
    },
    {
      "testName": "Hgb/HCT",
      "testCode": "",
      "price": 4,
      "cptCode": null
    },
    {
      "testName": "HIV 1 & 2 SCREEN",
      "testCode": "",
      "price": 10,
      "cptCode": null
    },
    {
      "testName": "HIV-1, RNAPCR (VIRAL LOAD)",
      "testCode": "",
      "price": 120,
      "cptCode": null
    },
    {
      "testName": "HOMOCYSTEINE",
      "testCode": "",
      "price": 25,
      "cptCode": null
    },
    {
      "testName": "HsCRP (Cardio)",
      "testCode": "",
      "price": 21.8,
      "cptCode": null
    },
    {
      "testName": "HUMAN GROWTH HORMONE",
      "testCode": "",
      "price": 55,
      "cptCode": null
    },
    {
      "testName": "HUMAN LEUKOCYTE ANTIGEN (HLA-B27)",
      "testCode": "",
      "price": 200,
      "cptCode": null
    },
    {
      "testName": "HUMAN PAPILLOMA VIRUS hc2",
      "testCode": "",
      "price": 98,
      "cptCode": null
    },
    {
      "testName": "HUMAN PAPILLOMA VIRUS hc2",
      "testCode": "",
      "price": 38,
      "cptCode": null
    },
    {
      "testName": "IFE (IMMUNOFIXATION, SERUM, PROTEIN ELECTROPHORESIS)",
      "testCode": "",
      "price": 90,
      "cptCode": null
    },
    {
      "testName": "IGF-1 (INSULIN-LIKE GROWTH FACTOR)",
      "testCode": "",
      "price": 40,
      "cptCode": null
    },
    {
      "testName": "IGF-3 (INSULIN-LIKE GROWTH FACTOR)",
      "testCode": "",
      "price": 50,
      "cptCode": null
    },
    {
      "testName": "IgA  (Immunoglobulin )",
      "testCode": "",
      "price": 9,
      "cptCode": null
    },
    {
      "testName": "IgB  (Immunoglobulin )",
      "testCode": "",
      "price": 25,
      "cptCode": null
    },
    {
      "testName": "IgE  (Immunoglobulin)",
      "testCode": "",
      "price": 8.5,
      "cptCode": null
    },
    {
      "testName": "IgG  (Immunoglobulin)",
      "testCode": "",
      "price": 9,
      "cptCode": null
    },
    {
      "testName": "IgM (Immunoglobulin )",
      "testCode": "",
      "price": 9,
      "cptCode": null
    },
    {
      "testName": "INFERTILITY WORK UP",
      "testCode": "",
      "price": 81,
      "cptCode": null
    },
    {
      "testName": "IMMUNOELECTROPHORESIS",
      "testCode": "",
      "price": 38,
      "cptCode": null
    },
    {
      "testName": "Immunoglobulin Igg-A-M",
      "testCode": "",
      "price": 42,
      "cptCode": null
    },
    {
      "testName": "INFLUENZA A/B",
      "testCode": "",
      "price": 70,
      "cptCode": null
    },
    {
      "testName": "INSULIN LEVEL",
      "testCode": "",
      "price": 20,
      "cptCode": null
    },
    {
      "testName": "INSULIN LIKE GROWTH FACTOR",
      "testCode": "",
      "price": 20,
      "cptCode": null
    },
    {
      "testName": "IRON",
      "testCode": "",
      "price": 5,
      "cptCode": null
    },
    {
      "testName": "IRON & IBC",
      "testCode": "",
      "price": 8.5,
      "cptCode": null
    },
    {
      "testName": "KEPPA/LAMBDA",
      "testCode": "",
      "price": 330,
      "cptCode": null
    },
    {
      "testName": "KEPRA LEVEL (Levetiracetam)",
      "testCode": "",
      "price": 60,
      "cptCode": null
    },
    {
      "testName": "LACOSAMIDE",
      "testCode": "",
      "price": 285,
      "cptCode": null
    },
    {
      "testName": "LACTIC ACID",
      "testCode": "",
      "price": 56,
      "cptCode": null
    },
    {
      "testName": "LDH (Lactate Dehydrogenase)",
      "testCode": "",
      "price": 4,
      "cptCode": null
    },
    {
      "testName": "LDL CHOLESTEROL",
      "testCode": "",
      "price": 6,
      "cptCode": null
    },
    {
      "testName": "LE LATEX",
      "testCode": "",
      "price": 6.5,
      "cptCode": null
    },
    {
      "testName": "LEAD BLOOD",
      "testCode": "",
      "price": 10,
      "cptCode": null
    },
    {
      "testName": "LEPTIN",
      "testCode": "",
      "price": 25,
      "cptCode": null
    },
    {
      "testName": "L.E. SCREEN",
      "testCode": "",
      "price": 10,
      "cptCode": null
    },
    {
      "testName": "LH",
      "testCode": "",
      "price": 10.94,
      "cptCode": null
    },
    {
      "testName": "LH 50",
      "testCode": "",
      "price": 100,
      "cptCode": null
    },
    {
      "testName": "LIPASE",
      "testCode": "",
      "price": 6.49,
      "cptCode": null
    },
    {
      "testName": "LIPID PANEL",
      "testCode": "",
      "price": 10,
      "cptCode": null
    },
    {
      "testName": "LIPOPROTEIN A",
      "testCode": "",
      "price": 25,
      "cptCode": null
    },
    {
      "testName": "LITHIUM",
      "testCode": "",
      "price": 7,
      "cptCode": null
    },
    {
      "testName": "LIVER PROFILE I",
      "testCode": "",
      "price": 8,
      "cptCode": null
    },
    {
      "testName": "LUPUS",
      "testCode": "",
      "price": 420,
      "cptCode": null
    },
    {
      "testName": "LUPUS ANTICOAGULANT SCREEN",
      "testCode": "",
      "price": 120,
      "cptCode": null
    },
    {
      "testName": "LYME AB TOTAL",
      "testCode": "",
      "price": 18,
      "cptCode": null
    },
    {
      "testName": "MAGNESIUM SERUM",
      "testCode": "",
      "price": 6.5,
      "cptCode": null
    },
    {
      "testName": "MEASELS",
      "testCode": "",
      "price": 10.5,
      "cptCode": null
    },
    {
      "testName": "MEASLES ANTIBODYlgG",
      "testCode": "",
      "price": 10,
      "cptCode": null
    },
    {
      "testName": "MEASLES ANTIBODYlgM",
      "testCode": "",
      "price": 105,
      "cptCode": null
    },
    {
      "testName": "METANEPHRINE 24 HRS URINE",
      "testCode": "",
      "price": 35,
      "cptCode": null
    },
    {
      "testName": "MICROALBUMIN 24 HRS URINE",
      "testCode": "",
      "price": 10.89,
      "cptCode": null
    },
    {
      "testName": "MICROALBUMIN RANDOM",
      "testCode": "",
      "price": 4,
      "cptCode": null
    },
    {
      "testName": "MITOCHONDRIAL TOTAL AB",
      "testCode": "",
      "price": 55,
      "cptCode": null
    },
    {
      "testName": "MMR TITER",
      "testCode": "",
      "price": 40,
      "cptCode": null
    },
    {
      "testName": "MONONUCLEOSIS TEST",
      "testCode": "",
      "price": 10,
      "cptCode": null
    },
    {
      "testName": "MUMPS",
      "testCode": "",
      "price": 10,
      "cptCode": null
    },
    {
      "testName": "MUMPS ANTIBODY lgG",
      "testCode": "",
      "price": 10,
      "cptCode": null
    },
    {
      "testName": "MUMPS ANTIBODY lgM",
      "testCode": "",
      "price": 57,
      "cptCode": null
    },
    {
      "testName": "MYCOPLASMA lgM TITER PNEUMONIAE ANTIBODY",
      "testCode": "",
      "price": 95,
      "cptCode": null
    },
    {
      "testName": "MYCOPLASMA PNEUMONIAE ANTIBODY lgG, lgM",
      "testCode": "",
      "price": 65,
      "cptCode": null
    },
    {
      "testName": "MYSOLINE (PRIMIDONE)",
      "testCode": "",
      "price": 15,
      "cptCode": null
    },
    {
      "testName": "NEISSERIA GONORRHEA, URINE, RRNA",
      "testCode": "",
      "price": 36,
      "cptCode": null
    },
    {
      "testName": "NEURONTIN (GABAPENTIN)",
      "testCode": "",
      "price": 80,
      "cptCode": null
    },
    {
      "testName": "NICOTINE METABOLITE URINE",
      "testCode": "",
      "price": 115,
      "cptCode": null
    },
    {
      "testName": "OBSTETRIC PANEL (ANTIBODY SCREEN)",
      "testCode": "",
      "price": 140,
      "cptCode": null
    },
    {
      "testName": "OBSTETRIC PANEL (withouth antibody screen)",
      "testCode": "",
      "price": 45,
      "cptCode": null
    },
    {
      "testName": "OCCULT BLOOD PER SPECIMEN",
      "testCode": "",
      "price": 5,
      "cptCode": null
    },
    {
      "testName": "OVA AND PARASITES",
      "testCode": "",
      "price": 5,
      "cptCode": null
    },
    {
      "testName": "OVARIAN PROFILE",
      "testCode": "",
      "price": 81.31,
      "cptCode": null
    },
    {
      "testName": "OVARIAN FUNCTION PANEL (LH, FSH, Progesterone, Prolactin, Estradiol, Testosterone)",
      "testCode": "",
      "price": 81,
      "cptCode": null
    },
    {
      "testName": "OXALATES - 24HRS",
      "testCode": "",
      "price": 74,
      "cptCode": null
    },
    {
      "testName": "OXALATES - URINE RANDOM",
      "testCode": "",
      "price": 140,
      "cptCode": null
    },
    {
      "testName": "PAP SMEAR",
      "testCode": "",
      "price": 15,
      "cptCode": null
    },
    {
      "testName": "PAP LIQUID Thinprep",
      "testCode": "",
      "price": 25,
      "cptCode": null
    },
    {
      "testName": "PAP PANEL (Liquide pap+HPVhc2+chlamydia&GC hc2",
      "testCode": "",
      "price": 25,
      "cptCode": null
    },
    {
      "testName": "PAP THIN PREP S/O",
      "testCode": "",
      "price": 60,
      "cptCode": null
    },
    {
      "testName": "PCR COVID-19 Nasal Swab",
      "testCode": "",
      "price": 60,
      "cptCode": null
    },
    {
      "testName": "PHENOBARBITAL",
      "testCode": "",
      "price": 15,
      "cptCode": null
    },
    {
      "testName": "PHENYTOIN (DILATIN)",
      "testCode": "",
      "price": 10,
      "cptCode": null
    },
    {
      "testName": "PHOSPHORUS",
      "testCode": "",
      "price": 4,
      "cptCode": null
    },
    {
      "testName": "PHV",
      "testCode": "",
      "price": 138,
      "cptCode": null
    },
    {
      "testName": "PLATELET COUNT",
      "testCode": "",
      "price": 4,
      "cptCode": null
    },
    {
      "testName": "POTASIUM",
      "testCode": "",
      "price": 4,
      "cptCode": null
    },
    {
      "testName": "POTASIUM IN URINE",
      "testCode": "",
      "price": 5,
      "cptCode": null
    },
    {
      "testName": "PRE - ALBUMIN",
      "testCode": "",
      "price": 7,
      "cptCode": null
    },
    {
      "testName": "PREGNANCY QUALITATIVE",
      "testCode": "",
      "price": 6,
      "cptCode": null
    },
    {
      "testName": "PREGNELONONE",
      "testCode": "",
      "price": 10,
      "cptCode": null
    },
    {
      "testName": "PREGNANCY TEST IN URINE",
      "testCode": "",
      "price": 5,
      "cptCode": null
    },
    {
      "testName": "PRIMIDONE",
      "testCode": "",
      "price": 40,
      "cptCode": null
    },
    {
      "testName": "PROCAINAMIDE (Pronestyl + Napa)",
      "testCode": "",
      "price": 106.5,
      "cptCode": null
    },
    {
      "testName": "PROGESTERONE",
      "testCode": "",
      "price": 10,
      "cptCode": null
    },
    {
      "testName": "PROLACTIN",
      "testCode": "",
      "price": 10,
      "cptCode": null
    },
    {
      "testName": "PROSTATE",
      "testCode": "",
      "price": 10,
      "cptCode": null
    },
    {
      "testName": "PROTEIN ELECTROPHORESIS",
      "testCode": "",
      "price": 10,
      "cptCode": null
    },
    {
      "testName": "PROTEIN IMMUNOFIC.",
      "testCode": "",
      "price": 55,
      "cptCode": null
    },
    {
      "testName": "PROTEIN TOTAL URINE 24HRS",
      "testCode": "",
      "price": 3.5,
      "cptCode": null
    },
    {
      "testName": "PROTEIN TOTAL SERUN",
      "testCode": "",
      "price": 4.62,
      "cptCode": null
    },
    {
      "testName": "PRO-BNP",
      "testCode": "",
      "price": 60,
      "cptCode": null
    },
    {
      "testName": "PSA FREE &TOTAL",
      "testCode": "",
      "price": 20,
      "cptCode": null
    },
    {
      "testName": "PSA FREE",
      "testCode": "",
      "price": 10,
      "cptCode": null
    },
    {
      "testName": "PSA TOTAL",
      "testCode": "",
      "price": 10,
      "cptCode": null
    },
    {
      "testName": "PSA  SCREEN",
      "testCode": "",
      "price": 10,
      "cptCode": null
    },
    {
      "testName": "PT",
      "testCode": "",
      "price": 3.5,
      "cptCode": null
    },
    {
      "testName": "PT/INR",
      "testCode": "",
      "price": 4.29,
      "cptCode": null
    },
    {
      "testName": "PT/PTT/INR",
      "testCode": "",
      "price": 7.59,
      "cptCode": null
    },
    {
      "testName": "PTT",
      "testCode": "",
      "price": 3.85,
      "cptCode": null
    },
    {
      "testName": "PTH INTACT",
      "testCode": "",
      "price": 3.5,
      "cptCode": null
    },
    {
      "testName": "QUINIDINE",
      "testCode": "",
      "price": 98,
      "cptCode": null
    },
    {
      "testName": "RA LATEX",
      "testCode": "",
      "price": 5,
      "cptCode": null
    },
    {
      "testName": "RECTIC COUNT",
      "testCode": "",
      "price": 3.85,
      "cptCode": null
    },
    {
      "testName": "RENAL FUNCTION PANEL",
      "testCode": "",
      "price": 4.8,
      "cptCode": null
    },
    {
      "testName": "RENIN",
      "testCode": "",
      "price": 96,
      "cptCode": null
    },
    {
      "testName": "RESPIRATORY PANEL (Flu)",
      "testCode": "",
      "price": 250,
      "cptCode": null
    },
    {
      "testName": "RH FACTOR (ONLY )",
      "testCode": "",
      "price": 10,
      "cptCode": null
    },
    {
      "testName": "RHEUMATOID FACTOR",
      "testCode": "",
      "price": 6,
      "cptCode": null
    },
    {
      "testName": "RPR",
      "testCode": "",
      "price": 3.85,
      "cptCode": null
    },
    {
      "testName": "RUBELLA AB ( IgG )",
      "testCode": "",
      "price": 10,
      "cptCode": null
    },
    {
      "testName": "RUBELLA AB  ( IgM )",
      "testCode": "",
      "price": 15,
      "cptCode": null
    },
    {
      "testName": "RUBEOLA ANTIBODY 1mg",
      "testCode": "",
      "price": 15,
      "cptCode": null
    },
    {
      "testName": "SSA",
      "testCode": "",
      "price": 40,
      "cptCode": null
    },
    {
      "testName": "SSB",
      "testCode": "",
      "price": 40,
      "cptCode": null
    },
    {
      "testName": "SED RATE",
      "testCode": "",
      "price": 3.5,
      "cptCode": null
    },
    {
      "testName": "SEMEN ANALYSIS",
      "testCode": "",
      "price": 40,
      "cptCode": null
    },
    {
      "testName": "SEROROTONIN (5-Hiaa)",
      "testCode": "",
      "price": 30,
      "cptCode": null
    },
    {
      "testName": "SERUM PROTEIN ELECTROPHORESIS",
      "testCode": "",
      "price": 31.99,
      "cptCode": null
    },
    {
      "testName": "SHBG - SEX HORMONE BINDING GLOBULIN",
      "testCode": "",
      "price": 45,
      "cptCode": null
    },
    {
      "testName": "SICKLE CELL SCREEN",
      "testCode": "",
      "price": 8.63,
      "cptCode": null
    },
    {
      "testName": "SLIDE PAP SMEAR (CONVENTIONAL)",
      "testCode": "",
      "price": 15,
      "cptCode": null
    },
    {
      "testName": "SMOOTH MUSCLE AB",
      "testCode": "",
      "price": 30,
      "cptCode": null
    },
    {
      "testName": "SODUIM (U ) 24HR",
      "testCode": "",
      "price": 5,
      "cptCode": null
    },
    {
      "testName": "SODIUM URINE",
      "testCode": "",
      "price": 4.5,
      "cptCode": null
    },
    {
      "testName": "SODIUM SERUM",
      "testCode": "",
      "price": 3.85,
      "cptCode": null
    },
    {
      "testName": "SPUTUM AND SENSITIVITY",
      "testCode": "",
      "price": 16.16,
      "cptCode": null
    },
    {
      "testName": "SPUTUM CULTURE",
      "testCode": "",
      "price": 15,
      "cptCode": null
    },
    {
      "testName": "STRONGILOIDE AB",
      "testCode": "",
      "price": 195,
      "cptCode": null
    },
    {
      "testName": "STONE ANALYSIS (KIDNEY )",
      "testCode": "",
      "price": 27,
      "cptCode": null
    },
    {
      "testName": "STOOL CULTURE AND SENSITIVITY",
      "testCode": "",
      "price": 20,
      "cptCode": null
    },
    {
      "testName": "STOOL CULTURE",
      "testCode": "",
      "price": 20,
      "cptCode": null
    },
    {
      "testName": "S FL RESPIRATORY ALLERGY PANEL",
      "testCode": "",
      "price": 155,
      "cptCode": null
    },
    {
      "testName": "T LYMPHOCYTES",
      "testCode": "",
      "price": 90,
      "cptCode": null
    },
    {
      "testName": "T3- FREE",
      "testCode": "",
      "price": 7,
      "cptCode": null
    },
    {
      "testName": "T3 -TOTAL",
      "testCode": "",
      "price": 5.44,
      "cptCode": null
    },
    {
      "testName": "T3-UPTAKE",
      "testCode": "",
      "price": 5.44,
      "cptCode": null
    },
    {
      "testName": "T3- REVERSE",
      "testCode": "",
      "price": 45,
      "cptCode": null
    },
    {
      "testName": "T4-TOTAL",
      "testCode": "",
      "price": 5.44,
      "cptCode": null
    },
    {
      "testName": "T4-FREE",
      "testCode": "",
      "price": 16.3,
      "cptCode": null
    },
    {
      "testName": "TACROLIMUS",
      "testCode": "",
      "price": 45,
      "cptCode": null
    },
    {
      "testName": "TB QUANTIFERON GOLD",
      "testCode": "",
      "price": 65,
      "cptCode": null
    },
    {
      "testName": "TEGRETOL",
      "testCode": "",
      "price": 20,
      "cptCode": null
    },
    {
      "testName": "TESTICULAR FUNCTION PANEL",
      "testCode": "",
      "price": 55,
      "cptCode": null
    },
    {
      "testName": "TESTOSTERONE",
      "testCode": "",
      "price": 16.5,
      "cptCode": null
    },
    {
      "testName": "TESTOSTERONE FREE & TOTAL",
      "testCode": "",
      "price": 18,
      "cptCode": null
    },
    {
      "testName": "THEOPHYLLINE",
      "testCode": "",
      "price": 25,
      "cptCode": null
    },
    {
      "testName": "THIAMINE LEVEL (VITAMIN B I )",
      "testCode": "",
      "price": 44,
      "cptCode": null
    },
    {
      "testName": "THIN PREP SMEAR (Liquid Base)",
      "testCode": "",
      "price": 38,
      "cptCode": null
    },
    {
      "testName": "THIN PREP SMEAR HPV REFLEX (Liquid Base)",
      "testCode": "",
      "price": 55,
      "cptCode": null
    },
    {
      "testName": "THROAT CULTURE AND SENSITIVITY",
      "testCode": "",
      "price": 10,
      "cptCode": null
    },
    {
      "testName": "THŸROGLOBULIN AB SCREEN",
      "testCode": "",
      "price": 25,
      "cptCode": null
    },
    {
      "testName": "THYROGLOBULIN",
      "testCode": "",
      "price": 25,
      "cptCode": null
    },
    {
      "testName": "THYROGLOBULIN QUANT.",
      "testCode": "",
      "price": 25,
      "cptCode": null
    },
    {
      "testName": "TOBRAMYCIN",
      "testCode": "",
      "price": 120,
      "cptCode": null
    },
    {
      "testName": "TOTAL PROTEIN 24HRS",
      "testCode": "",
      "price": 10,
      "cptCode": null
    },
    {
      "testName": "TOTAL PSA",
      "testCode": "",
      "price": 7.7,
      "cptCode": null
    },
    {
      "testName": "THYROID PANEL",
      "testCode": "",
      "price": 10,
      "cptCode": null
    },
    {
      "testName": "THYROID FUNCTION PANEL (TSH)",
      "testCode": "",
      "price": 8,
      "cptCode": null
    },
    {
      "testName": "THYROID PEROXIDE AB (TPO)",
      "testCode": "",
      "price": 25,
      "cptCode": null
    },
    {
      "testName": "THYROID STIMULATING IMMUNOGLOBULINS (TSI)",
      "testCode": "",
      "price": 120,
      "cptCode": null
    },
    {
      "testName": "TIBC (TOTAL IRON BINDING CAPACITY)",
      "testCode": "",
      "price": 5,
      "cptCode": null
    },
    {
      "testName": "TORCH PANEL",
      "testCode": "",
      "price": 610.6,
      "cptCode": null
    },
    {
      "testName": "TOXOPLASMA lgG",
      "testCode": "",
      "price": 6.58,
      "cptCode": null
    },
    {
      "testName": "TOXOPLASMA lgM",
      "testCode": "",
      "price": 6.58,
      "cptCode": null
    },
    {
      "testName": "TRANSFERRIN",
      "testCode": "",
      "price": 15,
      "cptCode": null
    },
    {
      "testName": "TRAZODONE",
      "testCode": "",
      "price": 116,
      "cptCode": null
    },
    {
      "testName": "TREPONEMA PALLIDUM TOTAL ANTIBODIES (FTA)",
      "testCode": "",
      "price": 30,
      "cptCode": null
    },
    {
      "testName": "TRICHOMONAS",
      "testCode": "",
      "price": 25,
      "cptCode": null
    },
    {
      "testName": "TRIGLYCERIDES",
      "testCode": "",
      "price": 5,
      "cptCode": null
    },
    {
      "testName": "TROPONIN 1",
      "testCode": "",
      "price": 35,
      "cptCode": null
    },
    {
      "testName": "TSH",
      "testCode": "",
      "price": 8,
      "cptCode": null
    },
    {
      "testName": "TSH WITH REFLEX FREE T4",
      "testCode": "",
      "price": 8,
      "cptCode": null
    },
    {
      "testName": "TPO",
      "testCode": "",
      "price": 40,
      "cptCode": null
    },
    {
      "testName": "UIBC",
      "testCode": "",
      "price": 11,
      "cptCode": null
    },
    {
      "testName": "URETHRAL AND SENSITIVITY",
      "testCode": "",
      "price": 14.6,
      "cptCode": null
    },
    {
      "testName": "URIC ACID",
      "testCode": "",
      "price": 4,
      "cptCode": null
    },
    {
      "testName": "URINE AND SENSITIVITY",
      "testCode": "",
      "price": 10,
      "cptCode": null
    },
    {
      "testName": "URINALYSIS",
      "testCode": "",
      "price": 4,
      "cptCode": null
    },
    {
      "testName": "URINALYSIS/MICROSCOPY",
      "testCode": "",
      "price": 4,
      "cptCode": null
    },
    {
      "testName": "URINE CÜLTURE",
      "testCode": "",
      "price": 9.6,
      "cptCode": null
    },
    {
      "testName": "URINE CYTOLOGY",
      "testCode": "",
      "price": 25,
      "cptCode": null
    },
    {
      "testName": "URINE HCG PREGNANCY TEST",
      "testCode": "",
      "price": 5,
      "cptCode": null
    },
    {
      "testName": "URINE PROTEIN RANDOM",
      "testCode": "",
      "price": 10.89,
      "cptCode": null
    },
    {
      "testName": "VAGINAL AND SENSITIVITY",
      "testCode": "",
      "price": 20,
      "cptCode": null
    },
    {
      "testName": "VAGINAL CULTURE",
      "testCode": "",
      "price": 20,
      "cptCode": null
    },
    {
      "testName": "VARICELLA ZOSTER ANTIBODY 1mg",
      "testCode": "",
      "price": 15.84,
      "cptCode": null
    },
    {
      "testName": "VALPROIC ACID (DEPAKITE)",
      "testCode": "",
      "price": 14,
      "cptCode": null
    },
    {
      "testName": "VANCOMICIN PEAK",
      "testCode": "",
      "price": 20,
      "cptCode": null
    },
    {
      "testName": "VANCOMICIN RANDOM",
      "testCode": "",
      "price": 20,
      "cptCode": null
    },
    {
      "testName": "VANCOMICIN THROUGH",
      "testCode": "",
      "price": 20,
      "cptCode": null
    },
    {
      "testName": "VARICELLA AB (lgG )",
      "testCode": "",
      "price": 15,
      "cptCode": null
    },
    {
      "testName": "VARICELLA ZOSTER IgG",
      "testCode": "",
      "price": 20,
      "cptCode": null
    },
    {
      "testName": "VDRL",
      "testCode": "",
      "price": 74,
      "cptCode": null
    },
    {
      "testName": "VITAMIN A",
      "testCode": "",
      "price": 71,
      "cptCode": null
    },
    {
      "testName": "VITAMIN B-l (THIAMINE)",
      "testCode": "",
      "price": 14,
      "cptCode": null
    },
    {
      "testName": "VITAMIN B-6",
      "testCode": "",
      "price": 26,
      "cptCode": null
    },
    {
      "testName": "VITAMIN B-12",
      "testCode": "",
      "price": 12,
      "cptCode": null
    },
    {
      "testName": "VITAMIN C",
      "testCode": "",
      "price": 85,
      "cptCode": null
    },
    {
      "testName": "VITAMIN D",
      "testCode": "",
      "price": 33.5,
      "cptCode": null
    },
    {
      "testName": "VITAMIN D 1.25 HYDROXY",
      "testCode": "",
      "price": 35,
      "cptCode": null
    },
    {
      "testName": "VMA (Vanillylmandelic Acid 24 hr Urine)",
      "testCode": "",
      "price": 69,
      "cptCode": null
    },
    {
      "testName": "WBC IN STOOL",
      "testCode": "",
      "price": 5,
      "cptCode": null
    },
    {
      "testName": "WBC/WDIFF",
      "testCode": "",
      "price": 4,
      "cptCode": null
    },
    {
      "testName": "WESTERN BLOT ANALYSIS",
      "testCode": "",
      "price": 71,
      "cptCode": null
    },
    {
      "testName": "WET MOUNT",
      "testCode": "",
      "price": 4,
      "cptCode": null
    },
    {
      "testName": "WET MOUNT FUNGUS & TRICH",
      "testCode": "",
      "price": 8.25,
      "cptCode": null
    },
    {
      "testName": "WOUND CULTURE AEROBIC",
      "testCode": "",
      "price": 4.95,
      "cptCode": null
    },
    {
      "testName": "WOUND CULTURE ANAEROBIC",
      "testCode": "",
      "price": 4.95,
      "cptCode": null
    },
    {
      "testName": "ZINC",
      "testCode": "",
      "price": 21,
      "cptCode": null
    }
  ],
  "dpoRates": [
    {
      "testName": "17-ALPHA HYDROPROGESTEROM",
      "testCode": "",
      "price": 41.4,
      "cptCode": "83498"
    },
    {
      "testName": "AB SCREEN (ANTIBODY SCREENING)",
      "testCode": "",
      "price": 10,
      "cptCode": "86850"
    },
    {
      "testName": "ABO AB SCREEN",
      "testCode": "",
      "price": 10,
      "cptCode": "86900"
    },
    {
      "testName": "ABO GROUP & AB SCREEN",
      "testCode": "",
      "price": 20,
      "cptCode": "86900-86901"
    },
    {
      "testName": "ABO RH (BLOOD GROUP)",
      "testCode": "",
      "price": 10,
      "cptCode": "86901"
    },
    {
      "testName": "ABSCESS CULTURE",
      "testCode": "",
      "price": 14,
      "cptCode": "87070"
    },
    {
      "testName": "ACTH (ADRENOCORTICOTROPIC HORMONE)",
      "testCode": "",
      "price": 40,
      "cptCode": "82024"
    },
    {
      "testName": "AFP",
      "testCode": "",
      "price": 14,
      "cptCode": "82105"
    },
    {
      "testName": "AFP TUMOR MARKER",
      "testCode": "",
      "price": 14,
      "cptCode": "82105"
    },
    {
      "testName": "ALBUMIN",
      "testCode": "",
      "price": 5,
      "cptCode": "82040"
    },
    {
      "testName": "ALBUMIN CREATININE RATION URINE",
      "testCode": "",
      "price": 10,
      "cptCode": "82043 -82570"
    },
    {
      "testName": "ALBUMIN URINE RANDOM",
      "testCode": "",
      "price": 10,
      "cptCode": "82042"
    },
    {
      "testName": "ALCOHOL IN URINE",
      "testCode": "",
      "price": 10,
      "cptCode": "82055"
    },
    {
      "testName": "ALDOLASE",
      "testCode": "",
      "price": 9.5,
      "cptCode": "82085"
    },
    {
      "testName": "ALKALINE PHOSPHATASE",
      "testCode": "",
      "price": 5,
      "cptCode": "84075"
    },
    {
      "testName": "ALLERGEN FOOD PANEL (ADULT) eachallergen ($9)",
      "testCode": "",
      "price": 50,
      "cptCode": "86003x15"
    },
    {
      "testName": "ALLERGEN RESPIRATORY PANEL(SUB-TROPICAL) eachallergen ($9)",
      "testCode": "",
      "price": 150,
      "cptCode": "82785, 86003 (x22)"
    },
    {
      "testName": "ALLERGY FOOD PANEL",
      "testCode": "",
      "price": 95,
      "cptCode": "86003X15"
    },
    {
      "testName": "ALLERGY PANEL PER ALLERGENeachallergen($9)",
      "testCode": "",
      "price": 10,
      "cptCode": "82785, 86003 (x22)"
    },
    {
      "testName": "ALPHA PHETO PROTEIN QUAD SCREEN",
      "testCode": "",
      "price": 59,
      "cptCode": "82105"
    },
    {
      "testName": "ALPHA PHETO PROTEIN TRIPLE SCREEN",
      "testCode": "",
      "price": 0,
      "cptCode": "N/A"
    },
    {
      "testName": "AFB",
      "testCode": "",
      "price": 30,
      "cptCode": "87015, 87116, 87206"
    },
    {
      "testName": "AFB CULTURE AND STAIN",
      "testCode": "",
      "price": 30,
      "cptCode": "87015, 87116, 87206"
    },
    {
      "testName": "ALT",
      "testCode": "",
      "price": 5,
      "cptCode": "84460"
    },
    {
      "testName": "AMMONIA",
      "testCode": "",
      "price": 10,
      "cptCode": "82140"
    },
    {
      "testName": "AMIKACIN SERUM",
      "testCode": "",
      "price": 14,
      "cptCode": "80150"
    },
    {
      "testName": "AMYLASE",
      "testCode": "",
      "price": 6,
      "cptCode": "82150"
    },
    {
      "testName": "ANEMIA PROFILE(Iron and Tibc, CBC W/Diff, Retic Count, Vit. B12, Ferritin, Transferrin, Folic Acid)",
      "testCode": "",
      "price": 65,
      "cptCode": "83550, 85027, 85045, 82607, 82728, 84466, 82746."
    },
    {
      "testName": "ANTI-CCP",
      "testCode": "",
      "price": 25,
      "cptCode": "86200"
    },
    {
      "testName": "ANTI -DNA",
      "testCode": "",
      "price": 25,
      "cptCode": "86225"
    },
    {
      "testName": "ANTI-PLAT.AB",
      "testCode": "",
      "price": 550,
      "cptCode": "86022"
    },
    {
      "testName": "ANTI MULLERIAN HORMONE",
      "testCode": "",
      "price": 190,
      "cptCode": "82166"
    },
    {
      "testName": "ANTI-THYROGLOBULIN ab (ATG)",
      "testCode": "",
      "price": 20,
      "cptCode": "86800"
    },
    {
      "testName": "ANTI-THYROID ANTIBODY",
      "testCode": "",
      "price": 20,
      "cptCode": "86376"
    },
    {
      "testName": "ANA W/REFLEX",
      "testCode": "",
      "price": 25,
      "cptCode": "86038"
    },
    {
      "testName": "AMA",
      "testCode": "",
      "price": 30,
      "cptCode": "86381"
    },
    {
      "testName": "ARTHRITIS PANEL",
      "testCode": "",
      "price": 30,
      "cptCode": "84550"
    },
    {
      "testName": "ASMA",
      "testCode": "",
      "price": 68,
      "cptCode": "86015"
    },
    {
      "testName": "ASO LATEX",
      "testCode": "",
      "price": 10,
      "cptCode": "86063, 86225, 85651, 86140, 86430."
    },
    {
      "testName": "AST (SGOT)",
      "testCode": "",
      "price": 5,
      "cptCode": "84450"
    },
    {
      "testName": "B-12 & FOLID ACID",
      "testCode": "",
      "price": 20,
      "cptCode": "82607"
    },
    {
      "testName": "B-12",
      "testCode": "",
      "price": 10,
      "cptCode": "82607"
    },
    {
      "testName": "BASIC METAB PANEL",
      "testCode": "",
      "price": 8,
      "cptCode": "80048, 82746."
    },
    {
      "testName": "BETA 2 MICROGLOBULIN",
      "testCode": "",
      "price": 16,
      "cptCode": "82232"
    },
    {
      "testName": "BIOPSY",
      "testCode": "",
      "price": 50,
      "cptCode": "88305"
    },
    {
      "testName": "BIOPSY - Level I - Gross only",
      "testCode": "",
      "price": 30,
      "cptCode": "88305"
    },
    {
      "testName": "BIOPSY - Level II",
      "testCode": "",
      "price": 40,
      "cptCode": "88305"
    },
    {
      "testName": "BIOPSY - Level III",
      "testCode": "",
      "price": 65,
      "cptCode": "88305"
    },
    {
      "testName": "BIOPSY - Level IV",
      "testCode": "",
      "price": 85,
      "cptCode": "88305"
    },
    {
      "testName": "BILIRUBIN DIRECT",
      "testCode": "",
      "price": 4,
      "cptCode": "82248"
    },
    {
      "testName": "BILIRUBIN INDIRECT",
      "testCode": "",
      "price": 4,
      "cptCode": "82248"
    },
    {
      "testName": "BILIRUBIN TOTAL",
      "testCode": "",
      "price": 4,
      "cptCode": "82247"
    },
    {
      "testName": "BLEEDING TIME",
      "testCode": "",
      "price": 4.5,
      "cptCode": "85002"
    },
    {
      "testName": "BUN",
      "testCode": "",
      "price": 4,
      "cptCode": "84520"
    },
    {
      "testName": "C3 COMPLEMENT",
      "testCode": "",
      "price": 16,
      "cptCode": "86160"
    },
    {
      "testName": "C4 COMPLEMENT",
      "testCode": "",
      "price": 16,
      "cptCode": "86161"
    },
    {
      "testName": "CA 125",
      "testCode": "",
      "price": 19.5,
      "cptCode": "86304"
    },
    {
      "testName": "CA 15-3",
      "testCode": "",
      "price": 19.5,
      "cptCode": "86300"
    },
    {
      "testName": "CA 19-9",
      "testCode": "",
      "price": 19.5,
      "cptCode": "86301"
    },
    {
      "testName": "CA 27-29",
      "testCode": "",
      "price": 19.5,
      "cptCode": "86300"
    },
    {
      "testName": "CALCIUM",
      "testCode": "",
      "price": 4,
      "cptCode": "82310"
    },
    {
      "testName": "CALCIUM IONIZED",
      "testCode": "",
      "price": 60,
      "cptCode": "82330"
    },
    {
      "testName": "CALCULUS (stone) ANALYSIS",
      "testCode": "",
      "price": 30,
      "cptCode": "82360"
    },
    {
      "testName": "CALCITONIN",
      "testCode": "",
      "price": 40,
      "cptCode": "82308"
    },
    {
      "testName": "CARBAMAZEPIN",
      "testCode": "",
      "price": 13,
      "cptCode": "80156"
    },
    {
      "testName": "CARDIAC PANEL",
      "testCode": "",
      "price": 28,
      "cptCode": "84450, 82550, 83615."
    },
    {
      "testName": "CARDIAC PROFILE",
      "testCode": "",
      "price": 64.82,
      "cptCode": "84450, 82550, 83615."
    },
    {
      "testName": "CBC",
      "testCode": "",
      "price": 5,
      "cptCode": "85027"
    },
    {
      "testName": "CBC W/DIF",
      "testCode": "",
      "price": 3.9,
      "cptCode": "85025"
    },
    {
      "testName": "CCP ANTIBODIES",
      "testCode": "",
      "price": 25,
      "cptCode": "86200"
    },
    {
      "testName": "CD4",
      "testCode": "",
      "price": 52,
      "cptCode": "86361"
    },
    {
      "testName": "CD8",
      "testCode": "",
      "price": 65,
      "cptCode": "86359, 86360"
    },
    {
      "testName": "CEA (Carcinoembryonic Antigen)",
      "testCode": "",
      "price": 15,
      "cptCode": "82378"
    },
    {
      "testName": "CELIAC PANEL",
      "testCode": "",
      "price": 285,
      "cptCode": "86364, 82784"
    },
    {
      "testName": "CERULOPLASMIN",
      "testCode": "",
      "price": 55,
      "cptCode": "82390"
    },
    {
      "testName": "CHLAMYDIA & GC IN URINE",
      "testCode": "",
      "price": 30,
      "cptCode": "87491-87591"
    },
    {
      "testName": "CHLAMYDIA & GC IN URINE AMPLIFIED PROBE",
      "testCode": "",
      "price": 30,
      "cptCode": "87491, 87591."
    },
    {
      "testName": "CHLAMYDIA & GC DNA",
      "testCode": "",
      "price": 30,
      "cptCode": "87491, 87591."
    },
    {
      "testName": "CHOLESTEROL",
      "testCode": "",
      "price": 5,
      "cptCode": "82465"
    },
    {
      "testName": "CHLORIDE",
      "testCode": "",
      "price": 4,
      "cptCode": "82435"
    },
    {
      "testName": "CLOSTRIDIUM DIFFICILE A",
      "testCode": "",
      "price": 19,
      "cptCode": "87449"
    },
    {
      "testName": "CLOSTRIDIUM DIFFICILE B",
      "testCode": "",
      "price": 19,
      "cptCode": "87324"
    },
    {
      "testName": "CLOSTRIDIUM DIFFICILE A/B",
      "testCode": "",
      "price": 19.95,
      "cptCode": "87230"
    },
    {
      "testName": "CLOZAPINE",
      "testCode": "",
      "price": 95,
      "cptCode": "80159"
    },
    {
      "testName": "CK (CPK TOTAL)",
      "testCode": "",
      "price": 7,
      "cptCode": "82550"
    },
    {
      "testName": "CMP",
      "testCode": "",
      "price": 7.2,
      "cptCode": "80053"
    },
    {
      "testName": "CMVlgG",
      "testCode": "",
      "price": 18,
      "cptCode": "86644"
    },
    {
      "testName": "CMVlgM",
      "testCode": "",
      "price": 18,
      "cptCode": "86645"
    },
    {
      "testName": "CO2 - BICARBONATO",
      "testCode": "",
      "price": 4,
      "cptCode": "82374"
    },
    {
      "testName": "COENZIME Q10",
      "testCode": "",
      "price": 65,
      "cptCode": "82542"
    },
    {
      "testName": "COMPRÉNH. METABOLIC PANEL",
      "testCode": "",
      "price": 10,
      "cptCode": "80053"
    },
    {
      "testName": "COOMBS DIRECT",
      "testCode": "",
      "price": 10,
      "cptCode": "86880"
    },
    {
      "testName": "COOMBS INDIRECT",
      "testCode": "",
      "price": 10,
      "cptCode": "86886"
    },
    {
      "testName": "COPPER",
      "testCode": "",
      "price": 18,
      "cptCode": "82525"
    },
    {
      "testName": "CORTISOL",
      "testCode": "",
      "price": 20,
      "cptCode": "82533"
    },
    {
      "testName": "COVID-19 IgG - QUAMTITATIVE (SPIKE)",
      "testCode": "",
      "price": 55,
      "cptCode": "86769"
    },
    {
      "testName": "COVID-19 IgG/IgM - QUAMTITATIVE",
      "testCode": "",
      "price": 40,
      "cptCode": "87635"
    },
    {
      "testName": "CLOSTRIDIUM DIFF.",
      "testCode": "",
      "price": 19.95,
      "cptCode": "87449"
    },
    {
      "testName": "C-PEPTIDE",
      "testCode": "",
      "price": 30,
      "cptCode": "84681"
    },
    {
      "testName": "CPK Total",
      "testCode": "",
      "price": 5,
      "cptCode": "82550"
    },
    {
      "testName": "CPK - MB (CREATINE KINASE MB FRACTION)",
      "testCode": "",
      "price": 20,
      "cptCode": "82553"
    },
    {
      "testName": "C-REACTIVE PROTEIN - QUANT",
      "testCode": "",
      "price": 8.9,
      "cptCode": "86141"
    },
    {
      "testName": "C-REACTIVE PROTEIN (CRP)",
      "testCode": "",
      "price": 5,
      "cptCode": "86140"
    },
    {
      "testName": "C-REACTIVE PROTEIN (CRP) ULTRASENSITIVE",
      "testCode": "",
      "price": 12.5,
      "cptCode": "86141"
    },
    {
      "testName": "CREATININE 24 HRS",
      "testCode": "",
      "price": 5,
      "cptCode": "82570"
    },
    {
      "testName": "CREATININE CLEARANCE",
      "testCode": "",
      "price": 8,
      "cptCode": "82575"
    },
    {
      "testName": "CREATININE KINASE TOTAL (CK)",
      "testCode": "",
      "price": 5,
      "cptCode": "82550"
    },
    {
      "testName": "CREATININE SERUM",
      "testCode": "",
      "price": 4,
      "cptCode": "82565"
    },
    {
      "testName": "CREATININE RANDOM URINE",
      "testCode": "",
      "price": 5,
      "cptCode": "82570"
    },
    {
      "testName": "CREATININE URINE 24 HRS",
      "testCode": "",
      "price": 5,
      "cptCode": "82570"
    },
    {
      "testName": "CRP",
      "testCode": "",
      "price": 8.9,
      "cptCode": "86140"
    },
    {
      "testName": "CULTURE & SENSIT",
      "testCode": "",
      "price": 12,
      "cptCode": "87077-87186"
    },
    {
      "testName": "CYSTATIN C",
      "testCode": "",
      "price": 35,
      "cptCode": "82610"
    },
    {
      "testName": "CYSTIC FIBROSIS",
      "testCode": "",
      "price": 250,
      "cptCode": "81220"
    },
    {
      "testName": "CH 50",
      "testCode": "",
      "price": 100,
      "cptCode": "86162"
    },
    {
      "testName": "DEPAKENE (VALPROIC ACID)",
      "testCode": "",
      "price": 12,
      "cptCode": "80164"
    },
    {
      "testName": "DHEA (DEHYDROEPIANDROSTERONE)",
      "testCode": "",
      "price": 26,
      "cptCode": "82626"
    },
    {
      "testName": "DHEA (DEHYDROEPIANDROSTERONE SALFATE)",
      "testCode": "",
      "price": 20,
      "cptCode": "82627"
    },
    {
      "testName": "DIGOXIN",
      "testCode": "",
      "price": 10,
      "cptCode": "80162"
    },
    {
      "testName": "DIHYDROTESTOSTERONE DHT",
      "testCode": "",
      "price": 35,
      "cptCode": "82642"
    },
    {
      "testName": "D-DIMER",
      "testCode": "",
      "price": 15,
      "cptCode": "85379"
    },
    {
      "testName": "DILANTIN LEVEL",
      "testCode": "",
      "price": 12,
      "cptCode": "80185"
    },
    {
      "testName": "DRUG SCREEN IN URINE",
      "testCode": "",
      "price": 23,
      "cptCode": "80307"
    },
    {
      "testName": "DRUG SCREEN 5",
      "testCode": "",
      "price": 25.9,
      "cptCode": "80100"
    },
    {
      "testName": "DRUG SCREEN 8",
      "testCode": "",
      "price": 35,
      "cptCode": "80101"
    },
    {
      "testName": "EAR AND SENSITIVITY",
      "testCode": "",
      "price": 12,
      "cptCode": "87070-87077-87186"
    },
    {
      "testName": "ELECTROLYTE PANEL",
      "testCode": "",
      "price": 4.5,
      "cptCode": "80051"
    },
    {
      "testName": "ENA (Smith AB, RNP AB, SSA, SSB)",
      "testCode": "",
      "price": 40,
      "cptCode": "86256, 86235, 86235 X2"
    },
    {
      "testName": "ERYTHROPOIETIN",
      "testCode": "",
      "price": 39,
      "cptCode": "82668"
    },
    {
      "testName": "ESTRADIOL",
      "testCode": "",
      "price": 15,
      "cptCode": "82670"
    },
    {
      "testName": "ESTRIOL",
      "testCode": "",
      "price": 20,
      "cptCode": "82677"
    },
    {
      "testName": "ESTROGEN TOTAL",
      "testCode": "",
      "price": 22,
      "cptCode": "82672"
    },
    {
      "testName": "ESR (SED RATE )",
      "testCode": "",
      "price": 6,
      "cptCode": "85651"
    },
    {
      "testName": "EYE AND SENSITIVITY",
      "testCode": "",
      "price": 12,
      "cptCode": "87077"
    },
    {
      "testName": "EYE CULTURE & SENSITIVITY",
      "testCode": "",
      "price": 12,
      "cptCode": "87077-87186"
    },
    {
      "testName": "FECAL GLOBYN BY IMMUNOCHEMISTRY",
      "testCode": "",
      "price": 13,
      "cptCode": "82274"
    },
    {
      "testName": "FERRITIN",
      "testCode": "",
      "price": 15,
      "cptCode": "82728"
    },
    {
      "testName": "FIBRINOGEN",
      "testCode": "",
      "price": 50,
      "cptCode": "85384"
    },
    {
      "testName": "FOLIC ACID (FOLATE )",
      "testCode": "",
      "price": 10,
      "cptCode": "82746"
    },
    {
      "testName": "FOOD ALLERGY",
      "testCode": "",
      "price": 110,
      "cptCode": "86003 X15"
    },
    {
      "testName": "FOOD ALLERGY PROFILE I",
      "testCode": "",
      "price": 120,
      "cptCode": "86003 X15"
    },
    {
      "testName": "FOOD ALLERGY PROFILE II",
      "testCode": "",
      "price": 110,
      "cptCode": "86003 X15"
    },
    {
      "testName": "FREE T3",
      "testCode": "",
      "price": 7,
      "cptCode": "84481"
    },
    {
      "testName": "FREE T4",
      "testCode": "",
      "price": 7,
      "cptCode": "84439"
    },
    {
      "testName": "FEMALE ENDOCRINE PROFILE (FSH, LH, ESTRADIOL, PROGESTERONE, PROLACTIN, TESTOSTERONE Total and Free, TSH)",
      "testCode": "",
      "price": 182.5,
      "cptCode": "83001, 83002, 82670, 84144, 84146, 82040, 84402, 84443."
    },
    {
      "testName": "FSH",
      "testCode": "",
      "price": 10,
      "cptCode": "83001"
    },
    {
      "testName": "FSH & LH",
      "testCode": "",
      "price": 20,
      "cptCode": "83001, 83002."
    },
    {
      "testName": "FINE NEEDLE ASPIRATION",
      "testCode": "",
      "price": 0,
      "cptCode": "N/A"
    },
    {
      "testName": "FRUCTOSAMINE",
      "testCode": "",
      "price": 32,
      "cptCode": "82985"
    },
    {
      "testName": "FTA AG",
      "testCode": "",
      "price": 45,
      "cptCode": "86781"
    },
    {
      "testName": "FUNGUS CULTURE",
      "testCode": "",
      "price": 16.5,
      "cptCode": "87101"
    },
    {
      "testName": "GENTAMYCIN",
      "testCode": "",
      "price": 25,
      "cptCode": "80170"
    },
    {
      "testName": "GC CULTURE",
      "testCode": "",
      "price": 30,
      "cptCode": "87590"
    },
    {
      "testName": "GGT",
      "testCode": "",
      "price": 10,
      "cptCode": "82297"
    },
    {
      "testName": "GGTP (GAMMA GT )",
      "testCode": "",
      "price": 5,
      "cptCode": "82297"
    },
    {
      "testName": "GLIADIN IgA,IgG",
      "testCode": "",
      "price": 80,
      "cptCode": "86258 (x2)"
    },
    {
      "testName": "GROUP & FACTOR",
      "testCode": "",
      "price": 10,
      "cptCode": "86900-86901"
    },
    {
      "testName": "GLUCOSE 2 HRS P.P",
      "testCode": "",
      "price": 4,
      "cptCode": "82947"
    },
    {
      "testName": "GLUCOSE 2 HRS TOLERANCE",
      "testCode": "",
      "price": 8,
      "cptCode": "82950"
    },
    {
      "testName": "GLUCOSE 3 HRS",
      "testCode": "",
      "price": 12,
      "cptCode": "82951"
    },
    {
      "testName": "GLUCOSE GRAY TUBE",
      "testCode": "",
      "price": 4,
      "cptCode": "82947"
    },
    {
      "testName": "GLUCOSE SERUM (FASTING )",
      "testCode": "",
      "price": 4,
      "cptCode": "82747"
    },
    {
      "testName": "GLYCOHEMOGLOBIN",
      "testCode": "",
      "price": 10,
      "cptCode": "83036"
    },
    {
      "testName": "H PYLORI AB IgG",
      "testCode": "",
      "price": 10,
      "cptCode": "86677"
    },
    {
      "testName": "H PYLORI BREATH",
      "testCode": "",
      "price": 55,
      "cptCode": "83013-83014"
    },
    {
      "testName": "H PYLORY IgM",
      "testCode": "",
      "price": 15,
      "cptCode": "86677"
    },
    {
      "testName": "H PYLORI IN STOOL (ANTIGEN )",
      "testCode": "",
      "price": 39,
      "cptCode": "87338"
    },
    {
      "testName": "H PYLORI QUALITATIVE",
      "testCode": "",
      "price": 7.15,
      "cptCode": "86677"
    },
    {
      "testName": "HAPTOGLOBULIN",
      "testCode": "",
      "price": 28,
      "cptCode": "83010"
    },
    {
      "testName": "HCG QUAL.",
      "testCode": "",
      "price": 7,
      "cptCode": "84703"
    },
    {
      "testName": "HCH QUANT.",
      "testCode": "",
      "price": 10.94,
      "cptCode": "84702"
    },
    {
      "testName": "HCG (Pregnancy Test) URINE",
      "testCode": "",
      "price": 5,
      "cptCode": "81025"
    },
    {
      "testName": "HDL CHOLESTEROL",
      "testCode": "",
      "price": 6,
      "cptCode": "83718"
    },
    {
      "testName": "HEMOGLOBIN A1C",
      "testCode": "",
      "price": 9,
      "cptCode": "83036"
    },
    {
      "testName": "HEMOGLOBIN  ELECTROPHORESIS",
      "testCode": "",
      "price": 23,
      "cptCode": "83020"
    },
    {
      "testName": "HEMOGLOBIN/HEMATROCRIT",
      "testCode": "",
      "price": 4,
      "cptCode": "85014-85018"
    },
    {
      "testName": "HEPATIC FUNTION PANEL (LFP)",
      "testCode": "",
      "price": 5.5,
      "cptCode": "80076"
    },
    {
      "testName": "HEPATITIS A IgM",
      "testCode": "",
      "price": 11.5,
      "cptCode": "86709"
    },
    {
      "testName": "HEPATITIS A TOTAL",
      "testCode": "",
      "price": 10.5,
      "cptCode": "86708"
    },
    {
      "testName": "HEPATITIS B Ags",
      "testCode": "",
      "price": 15.79,
      "cptCode": "87340"
    },
    {
      "testName": "HEPATITIS B CORE IgM AB",
      "testCode": "",
      "price": 11,
      "cptCode": "86705"
    },
    {
      "testName": "HEPATITIS B CORE TOTAL AB",
      "testCode": "",
      "price": 11,
      "cptCode": "86704"
    },
    {
      "testName": "HEPATITIS Bs AB",
      "testCode": "",
      "price": 11,
      "cptCode": "86706"
    },
    {
      "testName": "HEPATITIIS Bs AG",
      "testCode": "",
      "price": 10,
      "cptCode": "87340"
    },
    {
      "testName": "HEPATITIS B SURFACE AB",
      "testCode": "",
      "price": 22,
      "cptCode": "87340"
    },
    {
      "testName": "HEPATITIS C AB",
      "testCode": "",
      "price": 13.5,
      "cptCode": "86803"
    },
    {
      "testName": "HEPATITIS C Antibodies",
      "testCode": "",
      "price": 19,
      "cptCode": "86803"
    },
    {
      "testName": "HEPATITIS C RNA QUANT, PCR",
      "testCode": "",
      "price": 70,
      "cptCode": "87522"
    },
    {
      "testName": "HEPATITIS PANEL ABC",
      "testCode": "",
      "price": 35,
      "cptCode": "86709, 87340, 86803."
    },
    {
      "testName": "HEPATITIS PANEL ACUTE (Hep A, IgM, Hep B Ag Sur, Hep C Ab)",
      "testCode": "",
      "price": 51,
      "cptCode": "86709, 87340, 86803."
    },
    {
      "testName": "HERPES CULTURE",
      "testCode": "",
      "price": 35,
      "cptCode": "87252"
    },
    {
      "testName": "HERPES I ( IgG )",
      "testCode": "",
      "price": 12.5,
      "cptCode": "86695"
    },
    {
      "testName": "HERPES II ( IgG )",
      "testCode": "",
      "price": 15.79,
      "cptCode": "86696"
    },
    {
      "testName": "HERPES I  & II  ( IgM )",
      "testCode": "",
      "price": 18.5,
      "cptCode": "86694"
    },
    {
      "testName": "HERPES PANEL ABC (ACUTE)",
      "testCode": "",
      "price": 0,
      "cptCode": "N/A"
    },
    {
      "testName": "Hgb/HCT",
      "testCode": "",
      "price": 4,
      "cptCode": "85018-85014"
    },
    {
      "testName": "HIV 1 & 2 SCREEN",
      "testCode": "",
      "price": 10,
      "cptCode": "87389"
    },
    {
      "testName": "HIV-1, RNAPCR (VIRAL LOAD)",
      "testCode": "",
      "price": 120,
      "cptCode": "87536"
    },
    {
      "testName": "HOMOCYSTEINE",
      "testCode": "",
      "price": 25,
      "cptCode": "83090"
    },
    {
      "testName": "HsCRP (Cardio)",
      "testCode": "",
      "price": 21.8,
      "cptCode": "86141"
    },
    {
      "testName": "HUMAN GROWTH HORMONE",
      "testCode": "",
      "price": 55,
      "cptCode": "83003"
    },
    {
      "testName": "HUMAN LEUKOCYTE ANTIGEN (HLA-B27)",
      "testCode": "",
      "price": 200,
      "cptCode": "86812"
    },
    {
      "testName": "HUMAN PAPILLOMA VIRUS",
      "testCode": "",
      "price": 98,
      "cptCode": "87621"
    },
    {
      "testName": "IFE (IMMUNOFIXATION, SERUM, PROTEIN ELECTROPHORESIS)",
      "testCode": "",
      "price": 90,
      "cptCode": "84165"
    },
    {
      "testName": "IGF-1 (INSULIN-LIKE GROWTH FACTOR)",
      "testCode": "",
      "price": 40,
      "cptCode": "84305"
    },
    {
      "testName": "IGF-3 (INSULIN-LIKE GROWTH FACTOR)",
      "testCode": "",
      "price": 50,
      "cptCode": "83520"
    },
    {
      "testName": "IgA  (Immunoglobulin )",
      "testCode": "",
      "price": 9,
      "cptCode": "82784"
    },
    {
      "testName": "IgB  (Immunoglobulin )",
      "testCode": "",
      "price": 0,
      "cptCode": "N/A"
    },
    {
      "testName": "IgE  (Immunoglobulin)",
      "testCode": "",
      "price": 8.5,
      "cptCode": "82785"
    },
    {
      "testName": "IgG  (Immunoglobulin)",
      "testCode": "",
      "price": 9,
      "cptCode": "82784"
    },
    {
      "testName": "IgM (Immunoglobulin )",
      "testCode": "",
      "price": 9,
      "cptCode": "82784"
    },
    {
      "testName": "INFERTILITY WORK UP (Semen Analysis)",
      "testCode": "",
      "price": 81,
      "cptCode": "82306"
    },
    {
      "testName": "IMMUNOELECTROPHORESIS",
      "testCode": "",
      "price": 38,
      "cptCode": "82784 X3"
    },
    {
      "testName": "Immunoglobulin Igg-A-M",
      "testCode": "",
      "price": 42,
      "cptCode": "82784 X3"
    },
    {
      "testName": "INFLUENZA A/B",
      "testCode": "",
      "price": 70,
      "cptCode": "87804 X 2"
    },
    {
      "testName": "INSULIN LEVEL",
      "testCode": "",
      "price": 20,
      "cptCode": "83525"
    },
    {
      "testName": "INSULIN LIKE GROWTH FACTOR",
      "testCode": "",
      "price": 20,
      "cptCode": "84305"
    },
    {
      "testName": "IRON",
      "testCode": "",
      "price": 5,
      "cptCode": "83540"
    },
    {
      "testName": "IRON & IBC",
      "testCode": "",
      "price": 8.5,
      "cptCode": "83550"
    },
    {
      "testName": "KAPPA/LAMBDA",
      "testCode": "",
      "price": 330,
      "cptCode": "86325 X2"
    },
    {
      "testName": "KEPRA LEVEL (Levetiracetam)",
      "testCode": "",
      "price": 60,
      "cptCode": "80177"
    },
    {
      "testName": "LACOSAMIDE",
      "testCode": "",
      "price": 285,
      "cptCode": "80235"
    },
    {
      "testName": "LACTIC ACID",
      "testCode": "",
      "price": 56,
      "cptCode": "83605"
    },
    {
      "testName": "LDH (Lactate Dehydrogenase)",
      "testCode": "",
      "price": 4,
      "cptCode": "83615"
    },
    {
      "testName": "LDL CHOLESTEROL",
      "testCode": "",
      "price": 6,
      "cptCode": "83721"
    },
    {
      "testName": "LE LATEX",
      "testCode": "",
      "price": 6.5,
      "cptCode": "86130"
    },
    {
      "testName": "LEAD BLOOD",
      "testCode": "",
      "price": 10,
      "cptCode": "83655"
    },
    {
      "testName": "LEPTIN",
      "testCode": "",
      "price": 25,
      "cptCode": "83520"
    },
    {
      "testName": "L.E. SCREEN",
      "testCode": "",
      "price": 10,
      "cptCode": "86403"
    },
    {
      "testName": "LH",
      "testCode": "",
      "price": 10.94,
      "cptCode": "83002"
    },
    {
      "testName": "LIPASE",
      "testCode": "",
      "price": 6.49,
      "cptCode": "83690"
    },
    {
      "testName": "LIPID PANEL",
      "testCode": "",
      "price": 10,
      "cptCode": "80061"
    },
    {
      "testName": "LIPOPROTEIN A",
      "testCode": "",
      "price": 25,
      "cptCode": "83695"
    },
    {
      "testName": "LITHIUM",
      "testCode": "",
      "price": 7,
      "cptCode": "80170"
    },
    {
      "testName": "LIVER PROFILE I",
      "testCode": "",
      "price": 8,
      "cptCode": "80076"
    },
    {
      "testName": "LUPUS",
      "testCode": "",
      "price": 420,
      "cptCode": "85613"
    },
    {
      "testName": "LUPUS ANTICOAGULANT SCREEN",
      "testCode": "",
      "price": 120,
      "cptCode": "8530085730"
    },
    {
      "testName": "LYME AB TOTAL",
      "testCode": "",
      "price": 18,
      "cptCode": "86618"
    },
    {
      "testName": "MAGNESIUM SERUM",
      "testCode": "",
      "price": 6.5,
      "cptCode": "83735"
    },
    {
      "testName": "MEASLES",
      "testCode": "",
      "price": 10.5,
      "cptCode": "86765"
    },
    {
      "testName": "MEASLES ANTIBODYlgG",
      "testCode": "",
      "price": 10,
      "cptCode": "86765"
    },
    {
      "testName": "MEASLES ANTIBODYlgM",
      "testCode": "",
      "price": 105,
      "cptCode": "86765"
    },
    {
      "testName": "METANEPHRINE 24 HRS URINE",
      "testCode": "",
      "price": 35,
      "cptCode": "83835"
    },
    {
      "testName": "MICROALBUMIN 24 HRS URINE",
      "testCode": "",
      "price": 10.89,
      "cptCode": "82044"
    },
    {
      "testName": "MICROALBUMIN RANDOM",
      "testCode": "",
      "price": 4,
      "cptCode": "82043"
    },
    {
      "testName": "MITOCHONDRIAL TOTAL AB",
      "testCode": "",
      "price": 55,
      "cptCode": "86381"
    },
    {
      "testName": "MMR TITER",
      "testCode": "",
      "price": 40,
      "cptCode": "86735, 86765, 86762."
    },
    {
      "testName": "MONONUCLEOSIS TEST",
      "testCode": "",
      "price": 10,
      "cptCode": "86318"
    },
    {
      "testName": "MUMPS",
      "testCode": "",
      "price": 10,
      "cptCode": "86735"
    },
    {
      "testName": "MUMPS ANTIBODY lgG",
      "testCode": "",
      "price": 10,
      "cptCode": "86735"
    },
    {
      "testName": "MUMPS ANTIBODY lgM",
      "testCode": "",
      "price": 57,
      "cptCode": "86735"
    },
    {
      "testName": "MYCOPLASMA lgM TITER PNEUMONIAE ANTIBODY",
      "testCode": "",
      "price": 95,
      "cptCode": "86738"
    },
    {
      "testName": "MYCOPLASMA PNEUMONIAE ANTIBODY lgG, lgM",
      "testCode": "",
      "price": 65,
      "cptCode": "86738 (x2)"
    },
    {
      "testName": "MYSOLINE (PRIMIDONE)",
      "testCode": "",
      "price": 15,
      "cptCode": "80188, 80184."
    },
    {
      "testName": "NEISSERIA GONORRHEA, URINE, RRNA",
      "testCode": "",
      "price": 36,
      "cptCode": "87591"
    },
    {
      "testName": "NEURONTIN (GABAPENTIN)",
      "testCode": "",
      "price": 80,
      "cptCode": "80299"
    },
    {
      "testName": "NICOTINE METABOLITE URINE",
      "testCode": "",
      "price": 115,
      "cptCode": "82491, 80323."
    },
    {
      "testName": "OBSTETRIC PANEL (ANTIBODY SCREEN)",
      "testCode": "",
      "price": 140,
      "cptCode": "82947, 86592, 86900, 86901, 86762, 85027, 85025, 86850."
    },
    {
      "testName": "OBSTETRIC PANEL (withouth antibody screen)",
      "testCode": "",
      "price": 45,
      "cptCode": "82947, 86592, 86900, 86901, 86762, 85027, 85025."
    },
    {
      "testName": "OCCULT BLOOD PER SPECIMEN",
      "testCode": "",
      "price": 5,
      "cptCode": "82270"
    },
    {
      "testName": "OVA AND PARASITES",
      "testCode": "",
      "price": 5,
      "cptCode": "87177"
    },
    {
      "testName": "OVARIAN PROFILE",
      "testCode": "",
      "price": 81.31,
      "cptCode": "83002, 83001, 84144, 84146, 82670, 82040."
    },
    {
      "testName": "OVARIAN FUNCTION PANEL (LH, FSH, Progesterone, Prolactin, Estradiol, Testosterone)",
      "testCode": "",
      "price": 81,
      "cptCode": "83002, 83001, 84144, 84146, 82670, 82040."
    },
    {
      "testName": "OXALATES - 24HRS",
      "testCode": "",
      "price": 74,
      "cptCode": "82570, 83945."
    },
    {
      "testName": "OXALATES - URINE RANDOM",
      "testCode": "",
      "price": 140,
      "cptCode": "82570, 83945."
    },
    {
      "testName": "PAP SMEAR",
      "testCode": "",
      "price": 15,
      "cptCode": "88164"
    },
    {
      "testName": "PAP LIQUID Thinprep",
      "testCode": "",
      "price": 25,
      "cptCode": "88142"
    },
    {
      "testName": "PAP PANEL (Liquide pap+HPVhc2+chlamydia&GC hc2",
      "testCode": "",
      "price": 25,
      "cptCode": "88142, 87621, 87491, 87591."
    },
    {
      "testName": "PAP THIN PREP S/O",
      "testCode": "",
      "price": 60,
      "cptCode": "88142"
    },
    {
      "testName": "PCR COVID-19 Nasal Swab",
      "testCode": "",
      "price": 60,
      "cptCode": "U0003"
    },
    {
      "testName": "PHENOBARBITAL",
      "testCode": "",
      "price": 15,
      "cptCode": "80184"
    },
    {
      "testName": "PHENYTOIN (DILATIN)",
      "testCode": "",
      "price": 10,
      "cptCode": "80185"
    },
    {
      "testName": "PHOSPHORUS",
      "testCode": "",
      "price": 4,
      "cptCode": "84100"
    },
    {
      "testName": "HPV",
      "testCode": "",
      "price": 138,
      "cptCode": "87621"
    },
    {
      "testName": "PLATELET COUNT",
      "testCode": "",
      "price": 4,
      "cptCode": "85049"
    },
    {
      "testName": "POTASIUM",
      "testCode": "",
      "price": 4,
      "cptCode": "74132"
    },
    {
      "testName": "POTASIUM IN URINE",
      "testCode": "",
      "price": 5,
      "cptCode": "84133"
    },
    {
      "testName": "PRE - ALBUMIN",
      "testCode": "",
      "price": 7,
      "cptCode": "84134"
    },
    {
      "testName": "PREGNANCY QUALITATIVE",
      "testCode": "",
      "price": 6,
      "cptCode": "84703"
    },
    {
      "testName": "PREGNELONONE",
      "testCode": "",
      "price": 10,
      "cptCode": "84140"
    },
    {
      "testName": "PREGNANCY TEST IN URINE",
      "testCode": "",
      "price": 5,
      "cptCode": "81025"
    },
    {
      "testName": "PRIMIDONE",
      "testCode": "",
      "price": 40,
      "cptCode": "80188, 80184"
    },
    {
      "testName": "PROCAINAMIDE (Pronestyl + Napa)",
      "testCode": "",
      "price": 106.5,
      "cptCode": "80192"
    },
    {
      "testName": "PROGESTERONE",
      "testCode": "",
      "price": 10,
      "cptCode": "84144"
    },
    {
      "testName": "PROLACTIN",
      "testCode": "",
      "price": 10,
      "cptCode": "84146"
    },
    {
      "testName": "PROSTATE",
      "testCode": "",
      "price": 10,
      "cptCode": "84153"
    },
    {
      "testName": "PROTEIN ELECTROPHORESIS",
      "testCode": "",
      "price": 10,
      "cptCode": "84165"
    },
    {
      "testName": "PROTEIN IMMUNOFIC.",
      "testCode": "",
      "price": 55,
      "cptCode": "84166"
    },
    {
      "testName": "PROTEIN TOTAL URINE 24HRS",
      "testCode": "",
      "price": 3.5,
      "cptCode": "84156"
    },
    {
      "testName": "PROTEIN TOTAL SERUN",
      "testCode": "",
      "price": 4.62,
      "cptCode": "84155"
    },
    {
      "testName": "PRO-BNP",
      "testCode": "",
      "price": 60,
      "cptCode": "83880"
    },
    {
      "testName": "PSA FREE &TOTAL",
      "testCode": "",
      "price": 20,
      "cptCode": "84153, 84154."
    },
    {
      "testName": "PSA FREE",
      "testCode": "",
      "price": 10,
      "cptCode": "84154"
    },
    {
      "testName": "PSA TOTAL",
      "testCode": "",
      "price": 10,
      "cptCode": "84153"
    },
    {
      "testName": "PSA  SCREEN",
      "testCode": "",
      "price": 10,
      "cptCode": "G0103"
    },
    {
      "testName": "PT",
      "testCode": "",
      "price": 3.5,
      "cptCode": "85610"
    },
    {
      "testName": "PT/INR",
      "testCode": "",
      "price": 4.29,
      "cptCode": "85610"
    },
    {
      "testName": "PT/PTT/INR",
      "testCode": "",
      "price": 7.59,
      "cptCode": "85610, 85730."
    },
    {
      "testName": "PTT",
      "testCode": "",
      "price": 3.85,
      "cptCode": "85730"
    },
    {
      "testName": "PTH INTACT",
      "testCode": "",
      "price": 3.5,
      "cptCode": "83970"
    },
    {
      "testName": "QUINIDINE",
      "testCode": "",
      "price": 98,
      "cptCode": "80194"
    },
    {
      "testName": "RA LATEX",
      "testCode": "",
      "price": 5,
      "cptCode": "86430"
    },
    {
      "testName": "RECTIC COUNT",
      "testCode": "",
      "price": 3.85,
      "cptCode": "84055"
    },
    {
      "testName": "RENAL FUNCTION PANEL",
      "testCode": "",
      "price": 4.8,
      "cptCode": "80069"
    },
    {
      "testName": "RENIN",
      "testCode": "",
      "price": 96,
      "cptCode": "84244"
    },
    {
      "testName": "RESPIRATORY PANEL (Flu)",
      "testCode": "",
      "price": 250,
      "cptCode": "86710"
    },
    {
      "testName": "RH FACTOR (ONLY )",
      "testCode": "",
      "price": 10,
      "cptCode": "86901"
    },
    {
      "testName": "RHEUMATOID FACTOR",
      "testCode": "",
      "price": 6,
      "cptCode": "86430"
    },
    {
      "testName": "RPR",
      "testCode": "",
      "price": 3.85,
      "cptCode": "86592"
    },
    {
      "testName": "RUBELLA AB ( IgG )",
      "testCode": "",
      "price": 10,
      "cptCode": "86762"
    },
    {
      "testName": "RUBELLA AB  ( IgM )",
      "testCode": "",
      "price": 15,
      "cptCode": "86762"
    },
    {
      "testName": "RUBEOLA ANTIBODY 1mg",
      "testCode": "",
      "price": 15,
      "cptCode": "86765"
    },
    {
      "testName": "SSA",
      "testCode": "",
      "price": 40,
      "cptCode": "86225"
    },
    {
      "testName": "SSB",
      "testCode": "",
      "price": 40,
      "cptCode": "86225"
    },
    {
      "testName": "SED RATE",
      "testCode": "",
      "price": 3.5,
      "cptCode": "85651"
    },
    {
      "testName": "SEMEN ANALYSIS",
      "testCode": "",
      "price": 40,
      "cptCode": "89310"
    },
    {
      "testName": "SEROROTONIN (5-Hiaa)",
      "testCode": "",
      "price": 30,
      "cptCode": "842, 608, 349, 782, 570."
    },
    {
      "testName": "SERUM PROTEIN ELECTROPHORESIS",
      "testCode": "",
      "price": 31.99,
      "cptCode": "84165"
    },
    {
      "testName": "SHBG - SEX HORMONE BINDING GLOBULIN",
      "testCode": "",
      "price": 45,
      "cptCode": "84270"
    },
    {
      "testName": "SICKLE CELL SCREEN",
      "testCode": "",
      "price": 8.63,
      "cptCode": "85660"
    },
    {
      "testName": "SLIDE PAP SMEAR (CONVENTIONAL)",
      "testCode": "",
      "price": 15,
      "cptCode": "18500-9"
    },
    {
      "testName": "SMOOTH MUSCLE AB",
      "testCode": "",
      "price": 30,
      "cptCode": "86256, 86015."
    },
    {
      "testName": "SODUIM (U ) 24HR",
      "testCode": "",
      "price": 5,
      "cptCode": "84300"
    },
    {
      "testName": "SODIUM URINE",
      "testCode": "",
      "price": 4.5,
      "cptCode": "84300"
    },
    {
      "testName": "SODIUM SERUM",
      "testCode": "",
      "price": 3.85,
      "cptCode": "84295"
    },
    {
      "testName": "SPUTUM AND SENSITIVITY",
      "testCode": "",
      "price": 16.16,
      "cptCode": "87070, 87077."
    },
    {
      "testName": "SPUTUM CULTURE",
      "testCode": "",
      "price": 15,
      "cptCode": "87070"
    },
    {
      "testName": "STRONGILOIDE AB",
      "testCode": "",
      "price": 195,
      "cptCode": "86682"
    },
    {
      "testName": "STONE ANALYSIS (KIDNEY )",
      "testCode": "",
      "price": 27,
      "cptCode": "82360"
    },
    {
      "testName": "STOOL CULTURE AND SENSITIVITY",
      "testCode": "",
      "price": 20,
      "cptCode": "87045, 87077."
    },
    {
      "testName": "STOOL CULTURE",
      "testCode": "",
      "price": 20,
      "cptCode": "87045"
    },
    {
      "testName": "S FL RESPIRATORY ALLERGY PANEL",
      "testCode": "",
      "price": 155,
      "cptCode": "82785, 86003 (x22)."
    },
    {
      "testName": "T LYMPHOCYTES",
      "testCode": "",
      "price": 90,
      "cptCode": "88180, 86359, 86360."
    },
    {
      "testName": "T3- FREE",
      "testCode": "",
      "price": 7,
      "cptCode": "84481"
    },
    {
      "testName": "T3 -TOTAL",
      "testCode": "",
      "price": 5.44,
      "cptCode": "84480"
    },
    {
      "testName": "T3-UPTAKE",
      "testCode": "",
      "price": 5.44,
      "cptCode": "84479"
    },
    {
      "testName": "T3- REVERSE",
      "testCode": "",
      "price": 45,
      "cptCode": "84482"
    },
    {
      "testName": "T4-TOTAL",
      "testCode": "",
      "price": 5.44,
      "cptCode": "84436"
    },
    {
      "testName": "T4-FREE",
      "testCode": "",
      "price": 16.3,
      "cptCode": "84439"
    },
    {
      "testName": "TACROLIMUS",
      "testCode": "",
      "price": 45,
      "cptCode": "80197"
    },
    {
      "testName": "TB QUANTIFERON GOLD",
      "testCode": "",
      "price": 65,
      "cptCode": "86481"
    },
    {
      "testName": "TEGRETOL",
      "testCode": "",
      "price": 20,
      "cptCode": "80156"
    },
    {
      "testName": "TESTICULAR FUNCTION PANEL",
      "testCode": "",
      "price": 55,
      "cptCode": "82040, 84402."
    },
    {
      "testName": "TESTOSTERONE",
      "testCode": "",
      "price": 16.5,
      "cptCode": "84403"
    },
    {
      "testName": "TESTOSTERONE FREE & TOTAL",
      "testCode": "",
      "price": 18,
      "cptCode": "84402"
    },
    {
      "testName": "THEOPHYLLINE",
      "testCode": "",
      "price": 25,
      "cptCode": "80198"
    },
    {
      "testName": "THIAMINE LEVEL (VITAMIN B I )",
      "testCode": "",
      "price": 44,
      "cptCode": "84425"
    },
    {
      "testName": "THIN PREP SMEAR (Liquid Base)",
      "testCode": "",
      "price": 38,
      "cptCode": "88164"
    },
    {
      "testName": "THIN PREP SMEAR HPV REFLEX (Liquid Base)",
      "testCode": "",
      "price": 55,
      "cptCode": "88161"
    },
    {
      "testName": "THROAT CULTURE AND SENSITIVITY",
      "testCode": "",
      "price": 10,
      "cptCode": "87070"
    },
    {
      "testName": "THŸROGLOBULIN AB SCREEN",
      "testCode": "",
      "price": 25,
      "cptCode": "84432"
    },
    {
      "testName": "THYROGLOBULIN",
      "testCode": "",
      "price": 25,
      "cptCode": "84432"
    },
    {
      "testName": "THYROGLOBULIN QUANT.",
      "testCode": "",
      "price": 25,
      "cptCode": "84432"
    },
    {
      "testName": "TOBRAMYCIN",
      "testCode": "",
      "price": 120,
      "cptCode": "80200"
    },
    {
      "testName": "TOTAL PROTEIN 24HRS",
      "testCode": "",
      "price": 10,
      "cptCode": "84155"
    },
    {
      "testName": "TOTAL PSA",
      "testCode": "",
      "price": 7.7,
      "cptCode": "84153"
    },
    {
      "testName": "THYROID PANEL",
      "testCode": "",
      "price": 10,
      "cptCode": "84443, 84479, 84436."
    },
    {
      "testName": "THYROID FUNCTION PANEL (TSH)",
      "testCode": "",
      "price": 8,
      "cptCode": "84443"
    },
    {
      "testName": "THYROID PEROXIDE AB (TPO)",
      "testCode": "",
      "price": 25,
      "cptCode": "86376"
    },
    {
      "testName": "THYROID STIMULATING IMMUNOGLOBULINS (TSI)",
      "testCode": "",
      "price": 120,
      "cptCode": "84445"
    },
    {
      "testName": "TIBC (TOTAL IRON BINDING CAPACITY)",
      "testCode": "",
      "price": 5,
      "cptCode": "83550"
    },
    {
      "testName": "TORCH PANEL",
      "testCode": "",
      "price": 610.6,
      "cptCode": "86644, 86695, 86696, 86762, 86777."
    },
    {
      "testName": "TOXOPLASMA lgG",
      "testCode": "",
      "price": 6.58,
      "cptCode": "86777"
    },
    {
      "testName": "TOXOPLASMA lgM",
      "testCode": "",
      "price": 6.58,
      "cptCode": "86778"
    },
    {
      "testName": "TRANSFERRIN",
      "testCode": "",
      "price": 15,
      "cptCode": "84466"
    },
    {
      "testName": "TRAZODONE",
      "testCode": "",
      "price": 116,
      "cptCode": "80299"
    },
    {
      "testName": "TREPONEMA PALLIDUM TOTAL ANTIBODIES (FTA)",
      "testCode": "",
      "price": 30,
      "cptCode": "86781"
    },
    {
      "testName": "TRICHOMONAS",
      "testCode": "",
      "price": 25,
      "cptCode": "87661"
    },
    {
      "testName": "TRIGLYCERIDES",
      "testCode": "",
      "price": 5,
      "cptCode": "84478"
    },
    {
      "testName": "TROPONIN 1",
      "testCode": "",
      "price": 35,
      "cptCode": "84484"
    },
    {
      "testName": "TSH",
      "testCode": "",
      "price": 8,
      "cptCode": "84443"
    },
    {
      "testName": "TSH WITH REFLEX FREE T4",
      "testCode": "",
      "price": 8,
      "cptCode": "84443, 84439."
    },
    {
      "testName": "TPO",
      "testCode": "",
      "price": 40,
      "cptCode": "86376"
    },
    {
      "testName": "UIBC",
      "testCode": "",
      "price": 11,
      "cptCode": "83550"
    },
    {
      "testName": "URETHRAL AND SENSITIVITY",
      "testCode": "",
      "price": 14.6,
      "cptCode": "87070"
    },
    {
      "testName": "URIC ACID",
      "testCode": "",
      "price": 4,
      "cptCode": "84550"
    },
    {
      "testName": "URINE AND SENSITIVITY",
      "testCode": "",
      "price": 10,
      "cptCode": "87086, 87088."
    },
    {
      "testName": "URINALYSIS",
      "testCode": "",
      "price": 4,
      "cptCode": "81000"
    },
    {
      "testName": "URINALYSIS/MICROSCOPY",
      "testCode": "",
      "price": 4,
      "cptCode": "81015"
    },
    {
      "testName": "URINE CÜLTURE",
      "testCode": "",
      "price": 9.6,
      "cptCode": "87086"
    },
    {
      "testName": "URINE CYTOLOGY",
      "testCode": "",
      "price": 25,
      "cptCode": "88112"
    },
    {
      "testName": "URINE HCG PREGNANCY TEST",
      "testCode": "",
      "price": 5,
      "cptCode": "81025"
    },
    {
      "testName": "URINE PROTEIN RANDOM",
      "testCode": "",
      "price": 10.89,
      "cptCode": "84156"
    },
    {
      "testName": "VAGINAL AND SENSITIVITY",
      "testCode": "",
      "price": 20,
      "cptCode": "87077"
    },
    {
      "testName": "VAGINAL CULTURE",
      "testCode": "",
      "price": 20,
      "cptCode": "87070"
    },
    {
      "testName": "VARICELLA ZOSTER ANTIBODY 1mg",
      "testCode": "",
      "price": 15.84,
      "cptCode": "86787"
    },
    {
      "testName": "VALPROIC ACID (DEPAKITE)",
      "testCode": "",
      "price": 14,
      "cptCode": "80164"
    },
    {
      "testName": "VANCOMICIN PEAK",
      "testCode": "",
      "price": 20,
      "cptCode": "80202"
    },
    {
      "testName": "VANCOMICIN RANDOM",
      "testCode": "",
      "price": 20,
      "cptCode": "80202"
    },
    {
      "testName": "VANCOMICIN THROUGH",
      "testCode": "",
      "price": 20,
      "cptCode": "80202"
    },
    {
      "testName": "VARICELLA AB (lgG )",
      "testCode": "",
      "price": 15,
      "cptCode": "86787"
    },
    {
      "testName": "VARICELLA ZOSTER IgG",
      "testCode": "",
      "price": 20,
      "cptCode": "86787"
    },
    {
      "testName": "VDRL",
      "testCode": "",
      "price": 74,
      "cptCode": "86592"
    },
    {
      "testName": "VITAMIN A",
      "testCode": "",
      "price": 71,
      "cptCode": "84590"
    },
    {
      "testName": "VITAMIN B-l (THIAMINE)",
      "testCode": "",
      "price": 14,
      "cptCode": "84425"
    },
    {
      "testName": "VITAMIN B-6",
      "testCode": "",
      "price": 26,
      "cptCode": "84207"
    },
    {
      "testName": "VITAMIN B-12",
      "testCode": "",
      "price": 12,
      "cptCode": "82607"
    },
    {
      "testName": "VITAMIN C",
      "testCode": "",
      "price": 85,
      "cptCode": "82180"
    },
    {
      "testName": "VITAMIN D",
      "testCode": "",
      "price": 33.5,
      "cptCode": "82306"
    },
    {
      "testName": "VITAMIN D 1.25 HYDROXY",
      "testCode": "",
      "price": 35,
      "cptCode": "82652"
    },
    {
      "testName": "VMA (Vanillylmandelic Acid 24 hr Urine)",
      "testCode": "",
      "price": 69,
      "cptCode": "84585"
    },
    {
      "testName": "WBC IN STOOL",
      "testCode": "",
      "price": 5,
      "cptCode": "89055"
    },
    {
      "testName": "WBC/WDIFF",
      "testCode": "",
      "price": 4,
      "cptCode": "85004, 85048."
    },
    {
      "testName": "WESTERN BLOT ANALYSIS",
      "testCode": "",
      "price": 71,
      "cptCode": "86701"
    },
    {
      "testName": "WET MOUNT",
      "testCode": "",
      "price": 4,
      "cptCode": "87210"
    },
    {
      "testName": "WET MOUNT FUNGUS & TRICH",
      "testCode": "",
      "price": 8.25,
      "cptCode": "87102, 87206."
    },
    {
      "testName": "WOUND CULTURE AEROBIC",
      "testCode": "",
      "price": 4.95,
      "cptCode": "87070"
    },
    {
      "testName": "WOUND CULTURE ANAEROBIC",
      "testCode": "",
      "price": 4.95,
      "cptCode": "87070"
    },
    {
      "testName": "ZINC",
      "testCode": "",
      "price": 21,
      "cptCode": "84630"
    }
  ]
};
